import React, { Component } from "react";
import ReactDOM from "react-dom";
import Parser from "html-react-parser";
import Frame from "react-frame-component";
import barLine from "../../../Assets/barchart-sep.png";
import Rxbg from "../../../Assets/diagonal-footer.png";
import OptometryImage from "../../../Assets/vision.png";
import JawImage from "../../../Assets/jaw.png";

const reportsStyles = `<style>

body, table, tr, td {
    font-family: 'Exo 2', sans-serif !important;
    margin: 0 !important;
}

.hsg-rx-bg {
    position: absolute;
    z-index: -1;
    width: 100%;
}

@font-face {
    font-family: "fontBold";
    src: url("../../../Fonts/hinted-MyriadSetPro-Bold.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Bold.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Bold.eot") format("eot");
    }

@font-face {
    font-family: "fontMedium";
    src: url("../../../Fonts/hinted-MyriadSetPro-Medium.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Medium.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Medium.eot") format("eot");
    }
@font-face {
    font-family: "fontSemibold";
    src: url("../../../Fonts/hinted-MyriadSetPro-Semibold.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Semibold.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Semibold.eot") format("eot");
    }
@font-face {
    font-family: "fontUltralight";
    src: url("../../../Fonts/hinted-MyriadSetPro-Ultralight.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Ultralight.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Ultralight.eot") format("eot");
    }

@font-face {
    font-family: "fontThin";
    src: url("../../../Fonts/hinted-MyriadSetPro-Thin.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Thin.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Thin.eot") format("eot");
    }

@font-face {
    font-family: "font";
    src: url("../../../Fonts/hinted-MyriadSetPro-Text.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Text.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Text.eot") format("eot");
    }
    

.hsg-report-download {
    position: absolute;
    right: 28px;
    top: 78px;
    color: grey;
}
  
.hsg-report-download-btn {
    text-transform: uppercase;
    margin-bottom: 10px;
    background: transparent;
    top: 21px;
    position: relative;
    border: 0px !important;
    font-family: sans-serif;
    font-size: 10pt;
    color: grey;
    left: 10px;
    cursor: pointer;
    font-family: "font", sans-serif;
    &:focus{
        border: 0px !important;
    }
}

.hsg-report-back-btn {
    display: inline-block;
    font-family: "fontBold", sans-serif;
    font-family: sans-serif;
    font-size: 10pt;
    color: grey;
    cursor: pointer;
    position: relative;
    top: 20px;
    font-weight: 600;
}

.hsg-report-download {
    z-index: 999;
}

.hsg-note::before {
    content: ' ';
    height: 0;
    width: 0;
    border-width: 16px 16px 16px 16px;
    border-style: solid;
    border-color: #878a94 transparent transparent transparent;
    position: absolute;
    margin-left: -35px;
    transform: rotate(90deg);
}

.hsg-bar-line {
    height: 2px;
    position: absolute;
    top: 405px;
    width: 400px;
    right: 31%;
}

</style>`;

const reportStyleDental = `<style>

.hsg-rx-bg {
    bottom: 0px; // 133px;
    height: 180px;
}

.hsg-dental-tick-1, .hsg-dental-tick-2 , .hsg-dental-tick-3 {
    text-align: center;
}

.rx-image {
    text-align: right;
}

.hsg-dental-school-info {
        font-size: 18px !important;
        font-family: "fontBold", sans-serif !important;
}

.hsg-checkup > span {
    position: relative;
    bottom: 8px;
    color: #6e6e6e !important;
    font-size: 12px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-bg > img {
    position: relative;
    width: 102%;
    bottom: 178px;
    height: 176px;
    z-index: -1;
}

.hsg-assessment-date {
    bottom: 4px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-header {
    font-size: 16px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3{
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif !important;
}


.hsg-overall-normal-value, .hsg-overall-attention-value, .hsg-dental-result-normal, .hsg-dental-result-attention {
    font-size: 28px !important;
    font-weight: bold !important;
    position: relative;
}

.hsg-overall-normal-value, .hsg-overall-attention-value {
    position: relative;
    left: 0% !important;
    top:0 !important;
    bottom: 0px !important;
}


.hsg-dental-graph > img {
    width: 256px !important;
    height: 105px !important;
}

.best-performance > img {
    width: 185px !important;
    height: 130px !important;
}

.hsg-dental-tick-1 {
    position: relative;
    top: 5px;
}

.hsg-dental-report-header {
    bottom: 5px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
}

.hsg-test-header, .hsg-test-header-top {
    font-size: 18px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-test-header-top {
    position: absolute;
}

// .hsg-dental-normal-bar, .hsg-dental-attention-bar {
//     background-repeat: repeat;
//     background-image: url(../../strip.png);
// }

.hsg-result, .hsg-dental-result-attention-label {
    position: relative;
    bottom: 22px;
}

.style-2 {
    width: 85px !important;
    height: 37px !important;
}

.style-3 {
    width: 67px !important;
    height: 30px !important;
}

.hsg-result-normal-value {
    position: relative;
    bottom: 10px;
}

.hsg-result-decayed {
    position: relative;
    bottom: 10px;
}

.hsg-dental-report-header {
    bottom: 4px;
    position: relative;
}

.hsg-bar-line {
  top: 358px;
}

@media screen and (max-width: 900px){
  
    .style-4 {
        right: 6.3%;
        position: relative;
    }
    
    .hsg-dental-report-header, .hsg-assessment-date  {
        right: 6%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
  

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        right: 3%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 2.5%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 3.5%;
    }

    .best-performance {
        position: relative;
        right: 6.5%;
    }

    .hsg-tooth-1 {
        position: relative;
      
    }

    .hsg-tooth-2 {
        position: relative;
       
    }

    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        right: 0.5%;
    }

    .hsg-overall-normal {
        position: relative;
        left: 0.5%;
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-bar-line {
        width: 250px;
        right: 28%;
    }
    .hsg-overall-attention {
        position: relative;
        right: 2.5%;
        bottom: 40px;
    }

}


@media screen and (min-width: 900px) and (max-width: 1100px) {
  
    .style-4 {
        right: 8%;
        position: relative;
    }
    
    .hsg-dental-report-header , .hsg-assessment-date {
        right: 8%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }
    .hsg-overall-attention {
        position: relative;
        right: 3.5%;
    bottom: 40px;
    }

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        left: 15%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 3%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 4%;
    }

    .best-performance {
        position: relative;
        right: 7%;
    }

    .hsg-tooth-1 {
        position: relative;
        
    }

    .hsg-tooth-2 {
        position: relative;
        
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-test-image > img {
        position: relative;
        left: 47%;
    }
    .hsg-test-image-1 > img {
        position: relative;
        left: 44%;
    }
    .hsg-test-image-2 > img {
        position: relative;
        left: 40%;
    }
    .hsg-test-image-3 > img {
        position: relative;
        left: 57%;
    }
    .hsg-test-image-4 > img {
        position: relative;
        left: 38%;
    }
    .hsg-test-image-5 > img {
        position: relative;
        left: 40%;
    }
   
    .hsg-test-image-jaw {
        position: relative;
        left: 8%;
    }

    .hsg-image-big > img {
        position: relative;
        left: 14%;
    }
    .hsg-bar-line {
        width: 250px;
        right: 30%;
    }

    .hsg-dental-result-normal {
        left: 6%;
    }

    .hsg-result {
        position: relative;
        left: 7.5%;
    }
}

@media screen and (min-width: 1100px) and (max-width: 1300px) {
 
    .style-4 {
        right: 9.5%;
        position: relative;
    }
    
    .hsg-dental-report-header, .hsg-assessment-date {
        right: 9.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }
    .hsg-overall-attention {
        position: relative;
        right: 4.5%;
        bottom: 40px;
    }

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        right: -8%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 9.5%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 10.5%;
    }

    .best-performance {
        position: relative;
        right: 12%;
    }

    .hsg-tooth-1 {
        position: relative;
        left: 3%;
    }

    .hsg-tooth-2 {
        position: relative;
        left: 2%;
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-test-image > img {
        position: relative;
        left: 63%;
    }
    .hsg-test-image-1 > img {
        position: relative;
        left: 56%;
    }
    .hsg-test-image-2 > img {
        position: relative;
        left: 51%;
    }
    .hsg-test-image-3 > img {
        position: relative;
        left: 73%;
    }
    .hsg-test-image-4 > img {
        position: relative;
        left: 50%;
    }
    .hsg-test-image-5 > img {
        position: relative;
        left: 51%;
    }
   
    .hsg-test-image-jaw {
        position: relative;
        left: 11%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 29%;
    }
    .hsg-bar-line {
        width: 260px;
        right: 32%;
    }

    .hsg-dental-result-normal {
        left: 5%;
    }

    .hsg-result {
        position: relative;
        left: 6.5%;
    }
}


@media screen and (min-width: 1300px) and (max-width: 1500px) {
  
    
    .style-4 {
        right: 10.5%;
        position: relative;
    }
    
    .hsg-dental-report-header , .hsg-assessment-date {
        right: 10.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 49%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative;
        right: 4.5%;
        bottom: 40px;
    }

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        right: -10%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 12.5%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 13.5%;
    }

    .best-performance {
        position: relative;
        right: 14%;
    }

    .hsg-tooth-1 {
        position: relative;
        left: 4%;
    }

    .hsg-tooth-2 {
        position: relative;
        left: 3%;
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-test-image > img {
        position: relative;
        left: 81%;
    }
    .hsg-test-image-1 > img {
        position: relative;
        left: 75%;
    }
    .hsg-test-image-2 > img {
        position: relative;
        left: 67%;
    }
    .hsg-test-image-3 > img {
        position: relative;
        left: 91%;
    }
    .hsg-test-image-4 > img {
        position: relative;
        left: 65%;
    }
    .hsg-test-image-5 > img {
        position: relative;
        left: 64%;
    }
   
    .hsg-test-image-jaw {
        position: relative;
        left: 14%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 42%;
    }
    .hsg-bar-line {
        width: 300px;
        right: 31.5%;
    }

    .hsg-dental-result-normal {
        left: 7%;
    }

    .hsg-result {
        position: relative;
        left: 8%;
    }
}


@media screen and (min-width: 1500px) and (max-width: 1700px) {

    
    .style-4 {
        right: 12%;
        position: relative;
    }
    
    .hsg-dental-report-header, .hsg-assessment-date  {
        right: 12%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 63%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative;
        right: 5%;
        bottom: 40px;
    }

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        right: -14%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 13.5%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 14.5%;
    }

    .best-performance {
        position: relative;
        right: 14%;
    }

    .hsg-tooth-1 {
        position: relative;
        left: 4%;
    }

    .hsg-tooth-2 {
        position: relative;
        left: 3%;
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-test-image > img {
        position: relative;
        left: 89%;
    }
    .hsg-test-image-1 > img {
        position: relative;
        left: 83%;
    }
    .hsg-test-image-2 > img {
        position: relative;
        left: 76%;
    }
    .hsg-test-image-3 > img {
        position: relative;
        left: 97%;
    }
    .hsg-test-image-4 > img {
        position: relative;
        left: 73%;
    }
    .hsg-test-image-5 > img {
        position: relative;
        left: 73%;
    }
   
    .hsg-test-image-jaw {
        position: relative;
        left: 16%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 52%;
    }
    .hsg-bar-line {
        width: 400px;
        right: 30%;
    }

    .hsg-dental-result-normal {
        left: 9%;
    }

    .hsg-result {
        position: relative;
        left: 9.5%;
    }
}

@media screen and (min-width: 1700px) {

    
    .style-4 {
        right: 12.5%;
        position: relative;
    }
    
    .hsg-dental-report-header, .hsg-assessment-date  {
        right: 12.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 185px;    
    }

    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative;
        right: 5%;
        bottom: 40px;
    }

    .hsg-dental-graph > img  {
        position: relative;
        bottom: 21px;
        right: -21%;
    }

    .hsg-dental-result-attention {
        position: relative;
        right: 14%;
    }

    .hsg-dental-result-attention-label {
        position: relative;
        right: 15%;
    }

    .best-performance {
        position: relative;
        right: 14%;
    }

    .hsg-tooth-1 {
        position: relative;
        left: 4%;
    }

    .hsg-tooth-2 {
        position: relative;
        left: 3%;
    }

    .hsg-result-normal-value, .hsg-result-decayed {
        position: relative;
        left: 18px;
    }
    .hsg-test-image > img {
        position: relative;
        left: 104%;
    }
    .hsg-test-image-1 > img {
        position: relative;
        left: 98%;
    }
    .hsg-test-image-2 > img {
        position: relative;
        left: 93%;
    }
    .hsg-test-image-3 > img {
        position: relative;
        left: 121%;
    }
    .hsg-test-image-4 > img {
        position: relative;
        left: 92%;
    }
    .hsg-test-image-5 > img {
        position: relative;
        left: 92%;
    }
   
    .hsg-test-image-jaw {
        position: relative;
        left: 20%;
    }
    .hsg-image-bg > img {
        position: relative;
        left: 52%;
    }
    .hsg-bar-line {
        width: 468px;
        right: 30%;
    }

    .hsg-dental-result-normal {
        left: 12%;
    }

    .hsg-result {
        position: relative;
        left: 12.5%;
    }
    .hsg-image-big {
        position: relative;
        left: 12%;
    }
}


</style>`;

const reportStyleENT = `<style>

.hsg-rx-bg {
    bottom: 0px; // 128px;
    height: 190px;
}

.hsg-ent-ticks-1, .hsg-ent-ticks-2, .hsg-ent-ticks-3 {
    text-align: center;
}

.rx-image {
    text-align: right;
}

.hsg-footer-text-2 {
    position: relative;
    bottom: 7px
}

.hsg-checkup > span {
    position: relative;
    bottom: 8px;
    color: #6e6e6e !important;
    font-size: 12px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-bg > img {
    position: relative;
    width: 100%;
    bottom: 196px;

    z-index: -1;
}

.hsg-assessment-date {
    position: relative;
    bottom: 5px;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-header {
    font-size: 16px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3{
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-text-3, .hsg-ent-ticks-3 > img {
    position: relative;
    bottom: 8px;
}

// .hsg-overall-normal, .hsg-overall-attention {
//     position: relative;
//     bottom: 20px;
// }

@media screen and (min-width: 1216px) {
    .hsg-ent-ticks-1 > img {
        position: relative;
        top: 7px;
    }
}

.hsg-overall-normal-value, .hsg-overall-attention-value, .hsg-result-normal, .hsg-result-attention {
    font-size: 28px !important;
    font-weight: bold !important;
}

.hsg-graph > img {
    width: 256px !important;
    height: 105px !important;
}

.best-performance  > img {
    width: 185px !important;
    height: 130px !important;
}
.hsg-ent-report-header {
    bottom: 3px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
}

.hsg-test-header, .hsg-test-header-top {
    font-size: 18px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-test-header-top {
    position: absolute;
}

// .hsg-ent-normal-bar, .hsg-ent-attention-bar {
//     background-repeat: repeat;
//     background-image: url(../../strip.png);
// }

.hsg-result, .hsg-result-attention-label {
    position: relative;
    bottom: 13px;
}

.hsg-ent-school-info {
    font-size: 18px !important;
    font-family: "fontBold", sans-serif !important;
}


.style-9 {
    font-size: 18px !important;
    font-weight: 600 !important;
}

.style-2 {
    width: 85px !important;
    height: 37px !important;
}


.style-3 {
    width: 67px !important;
    height: 30px !important;
}

.hsg-result-attention, .hsg-result-normal {
    position: relative;
    top: 10px;
}

.hsg-bar-line {
    top: 387px;
}

.hsg-overall-normal {
    bottom: 13px;
}

.hsg-overall-attention {
    bottom: 4px;
}

@media screen and (max-width: 900px){
  
    .style-4 {
        right: 6.3%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date {
        right: 6%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
  

    .hsg-graph > img  {
        position: relative;
        right: 7.5%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
       
    }
    .hsg-overall-normal{
        left: 0.5%;
    }

    .hsg-overall-normal-value  {
       right: 0.5%;
    }

    .hsg-overall-attention {
        right: 5%;
    }

    .hsg-overall-attention-value{
        right: 0.5%;
    }

    .hsg-result-attention {
        position: relative;
        right: 7.5%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 8.5%;
    }

    .best-performance {
        position: relative;
        right: 10%;
    }
    .hsg-bar-line {
        width: 228px;
        right: 25%; 
    }

   
}


@media screen and (min-width: 900px) and (max-width: 1100px) {
  
    .style-4 {
        right: 8%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date {
        right: 8%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
       
    }
    .hsg-overall-normal{
        left: 1%;
    }

    .hsg-overall-normal-value  {
       
    }

    .hsg-overall-attention {
        right: 5%;
    }

    .hsg-overall-attention-value{
        
    }

    .hsg-graph > img  {
        position: relative;
        left: 5%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 24%;
    }
    .hsg-result-attention {
        position: relative;
        right: 6.5%;
    }
    .hsg-image > img {
        position: relative;
        left: 46%;
    }
    .hsg-image-no > img {
        position: relative;
        left: 35%
    }

    .hsg-image-o > img {
        position: relative;
        left: 31%;
    }

    .hsg-image-n > img {
        position: relative;
        left: 31%;
    }
    .hsg-result-attention-label {
        position: relative;
        right: 7.5%;
    }

    .best-performance {
        position: relative;
        right: 10%;
    }
    .hsg-bar-line {
        width: 250px;
        right: 30%;
    }

    .hsg-result-normal {
        left: 4%;
    }

    .hsg-result {
        position: relative;
        left: 5%;
    }
}

@media screen and (min-width: 1100px) and (max-width: 1300px) {
 
    .style-4 {
        right: 9.5%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date{
        right: 9.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
       
    }

    .hsg-overall-normal{
        left: 1%;
    }

    .hsg-overall-normal-value  {
       
    }

    .hsg-overall-attention {
        right: 5%;
    }

    .hsg-overall-attention-value{
        
    }

    .hsg-graph > img  {
        position: relative;
        right: -3.5%;
    }

    .hsg-result-attention {
        position: relative;
        right: 10.5%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 11.5%;
    }

    .best-performance {
        position: relative;
        right: 14%;
    }
    .hsg-image > img {
        position: relative;
        left: 88%;
    }
    .hsg-image-no > img {
        position: relative;
        left: 67%
    }

    .hsg-image-o > img {
        position: relative;
        left: 56%;
    }

    .hsg-image-n > img {
        position: relative;
        left: 64%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 42%;
    }
    .hsg-bar-line {
        width: 300px;
        right: 29%;
    }

    .hsg-result-normal {
        left: 4%;
    }

    .hsg-result {
        position: relative;
        left: 5%;
    }
}


@media screen and (min-width: 1300px) and (max-width: 1500px) {
  
    
    .style-4 {
        right: 10.5%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date {
        right: 10.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 49%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
       
    }

    .hsg-overall-normal{
        left: 1%;
    }

    .hsg-overall-normal-value  {
        left: 0.5%;
    }

    .hsg-overall-attention {
        right: 5.5%;
    }

    .hsg-overall-attention-value{
        left: 0.5%;
    }

    .hsg-graph > img  {
        position: relative;
        right: -3.5%;
    }

    .hsg-result-attention {
        position: relative;
        right: 13%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 14%;
    }

    .best-performance {
        position: relative;
        right: 16%;
    }
    .hsg-image > img {
        position: relative;
        left: 100%;
    }
    .hsg-image-no > img {
        position: relative;
        left: 84%
    }

    .hsg-image-o > img {
        position: relative;
        left: 78%;
    }

    .hsg-image-n > img {
        position: relative;
        left: 64%;
    }
    .hsg-image-big > img {
        position: relative;
        left: 42%;
    }
    .hsg-bar-line {
        width: 350px;
        right: 30%;
    }

    .hsg-result-normal {
        left: 5%;
    }

    .hsg-result {
        position: relative;
        left: 6.5%;
    }
}


@media screen and (min-width: 1500px) and (max-width: 1700px) {

    
    .style-4 {
        right: 12%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date {
        right: 12%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 63%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
       
    }

    .hsg-overall-normal{
        left: 1%;
    }

    .hsg-overall-normal-value  {
        left: 0.5%;
    }

    .hsg-overall-attention {
        right: 4.5%;
    }

    .hsg-overall-attention-value{
        left: 0.5%;
    }

    .hsg-graph > img  {
        position: relative;
        right: -6.5%;
    }

    .hsg-result-attention {
        position: relative;
        right: 15.5%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 16.5%;
    }

    .best-performance {
        position: relative;
        right: 16%;
    }
    .hsg-image > img {
        position: relative;
        left: 112%;
    }
    .hsg-image-no > img {
        position: relative;
        left: 99%
    }

    .hsg-image-o > img {
        position: relative;
        left: 89%;
    }

    .hsg-image-n > img {
        position: relative;
        left: 76%;
    }

    .hsg-image-big > img {
        position: relative;
        left: 49%;
    }
    .hsg-bar-line {
        width: 380px;
        right: 30%;
    }

    .hsg-result-normal {
        left: 7%;
    }

    .hsg-result {
        position: relative;
        left: 8%;
    }
}

@media screen and (min-width: 1700px) {

    
    .style-4 {
        right: 12.5%;
        position: relative;
    }
    
    .hsg-ent-report-header, .hsg-assessment-date {
        right: 12.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 185px;    
    }

    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value, .hsg-overall-attention {
        position: relative;
      
    }

    .hsg-graph > img  {
        position: relative;
        right: -10.5%;
    }

    .hsg-overall-normal{
        left: 1%;
    }

    .hsg-overall-normal-value  {
        left: 0.5%;
    }

    .hsg-overall-attention {
        right: 5.2%;
    }

    .hsg-overall-attention-value{
        left: 0.5%;
    }

    .hsg-result-attention {
        position: relative;
        right: 17%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 17.5%;
    }

    .best-performance {
        position: relative;
        right: 16.5%;
    }
    .hsg-image > img {
        position: relative;
        left: 130%;
    }
    .hsg-image-no > img {
        position: relative;
        left: 112%
    }

    .hsg-image-o > img {
        position: relative;
        left: 102%;
    }

    .hsg-image-n > img {
        position: relative;
        left: 87%;
    }

    .hsg-image-big > img {
        position: relative;
        left: 60%;
    }
    .hsg-bar-line {
        width: 450px;
        right: 30%;
    }

    .hsg-result-normal {
        left: 9%;
    }

    .hsg-result {
        position: relative;
        left: 10%;
    }
}

</style>`;

const reportStyleEye = `<style>

.hsg-rx-bg {
    bottom: 0px; // 128px;
    height: 160px;
}

.hsg-ent-ticks-1, .hsg-ent-ticks-2 {
    text-align: center;
}

.rx-image {
    text-align: right;
}

.hsg-ent-ticks-2 {
    position: relative;
    bottom: 11px;
}

.hsg-footer-text-2 {
    position: relative;
    bottom: 6px;
}

.hsg-checkup > span {
    position: relative;
    bottom: 8px;
    color: #6e6e6e !important;
    font-size: 12px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-bg > img {
    position: relative;
    width: 100%;
    bottom: 169px;
    height: 152px;
    z-index: -1;
}

.hsg-assessment-date {
    position: relative;
    bottom: 5px;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-header {
    font-size: 16px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3{
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif !important;
}


.hsg-overall-normal {
    position: relative;
    bottom: 20px;
}

@media screen and (min-width: 1216px) {
    .hsg-eye-ticks-1 > img {
        position: relative;
        top: 7px;
    }
}

.hsg-overall-normal-value, .hsg-overall-attention-value, .hsg-clinical-normal-value, .hsg-clinical-attention-value {
    font-size: 28px !important;
    font-weight: bold !important;
}

.hsg-eye-graph > img {
    width: 300px !important;
    height: 108px !important;
}

.best-performance  > img {
    width: 185px !important;
    height: 130px !important;
}

.hsg-eye-report-header {
    bottom: 3px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
}

.hsg-test-header, .hsg-test-header-top {
    font-size: 18px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-test-header-top {
    position: absolute;
}

// .hsg-eye-normal-bar, .hsg-eye-attention-bar {
//     background-repeat: repeat;
//     background-image: url(../../strip.png);
// }

.hsg-result, .hsg-result-attention-label {
    position: relative;
    bottom: 13px;
}

.hsg-eye-school-info {
    font-size: 18px !important;
    font-family: "fontBold", sans-serif !important;
    color: #6e6e6e !important;
}


.style-2 {
    width: 85px !important;
    height: 37px !important;
}

.hsg-graph > img { 
    width: 300px !important;
    height: 108px !important;
}

.best-performance {
    width: 190px !important;
    height: 155px !important;
}

.hsg-optometry-normal-img > img, .hsg-optometry-attention-img > img {
    width: 120px !important;
    height: 120px !important;
}

.style-3 {
    width: 67px !important;
    height: 30px !important;
}

.hsg-eye-normal-label, .hsg-eye-need-attention-label  {
    font-size: 28px !important;
    font-weight: bold !important;
    position: relative;
    bottom: 25px;
}

.hsg-test, .hsg-clinical-attention-label {
    position: relative;
    bottom: 6px;
}

hsg-ent-ticks-2 > img {
    position: relative;
    bottom: 2px;
}

.hsg-optometry-normal-img, .hsg-optometry-attention-img {
    position: relative;
}

.hsg-eye-report-header {
   
    position: relative;
}

.hsg-overall-normal-value, .hsg-overall-attention-value {
    position: relative;
    bottom: 8px; 
}

.hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
    position: relative;
   
}

.hsg-clinical-attention-value, .hsg-clinical-normal-value {
    position: relative;
    top: 20px;
}

.hsg-bar-line {
    top: 346px;
}

.hsg-ent-ticks-2 {
    position: relative;
    bottom: 5px;
}

.hsg-image-main > img {
    width: 247px !important;
    height: 178px !important;
}

.hsg-image-big > img {
    width: 260px !important;
    height: 285px !important;
}

.hsg-image > img {
    width: 150px !important;
    height: 94px !important;
}

@media screen and (max-width: 900px){
  
    .style-4 {
        right: 6.3%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date {
        right: 6%;
        bottom: 9px;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
  
    .hsg-eye-graph > img {
        position: relative;
       
    }

    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 3.5%;
    }
    .hsg-clinical-attention-value {
        position: relative;
        left: 2%;
    }
   
    .hsg-clinical-attention-label {
        position: relative;
        right: 0%;
    }
    .hsg-eye-normal-label {
        left: 15.6%;
    }
    .hsg-eye-need-attention-label {
        right: 16.6%;
        top: -30px;
    }
    .hsg-bar-line {
        width: 176px;
        right: 27%;
    }

    .hsg-clinical-normal-value {
        left: 2%;
    }

    .hsg-test {
        position: relative;
        left: 2%;
    }

    .hsg-image-main {
        position: relative;
        left: 2%;
    }
}


@media screen and (min-width: 900px) and (max-width: 1100px) {
  
    .style-4 {
        right: 8%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date {
        right: 8%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 31%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }
    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 3.5%;
    }

    .hsg-eye-graph > img {
        position: relative;
        right: 7%;
    }

    .hsg-clinical-attention-value {
        position: relative;
        right: 12%;
    }

    .hsg-clinical-attention-label {
        position: relative;
        right: 13%;
    }

    .hsg-eye-normal-label {
        left: 13.3%;
    }
    .hsg-eye-need-attention-label {
        right: 27%;
        top: -30px;
    }
    .hsg-optometry-normal-img {
        
    }
    .hsg-optometry-attention-img {
        right: 8%;
    }
    .hsg-image {
        position: relative;
        left: 3%;
    }

    .best-performance {
        position: relative;
        right: 12%;
    }
    .hsg-bar-line {
        width: 215px;
        right: 27%;
    }

    .hsg-clinical-normal-value {
        left: 2%;
    }

    .hsg-test {
        position: relative;
        left: 2%;
    }

    .hsg-image-main {
        position: relative;
        left: 3%;
    }
}

@media screen and (min-width: 1100px) and (max-width: 1300px) {
 
    .style-4 {
        right: 9.5%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date{
        right: 9.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal {
        position: relative;
       
    }
    .hsg-overall-attention-value {
        position: relative;
    }

    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 4%;
    }

    .hsg-eye-graph > img {
        position: relative;
        right: -7%;
    }

    .hsg-clinical-attention-value {
        position: relative;
        right: 12%;
    }

    .hsg-clinical-attention-label {
        position: relative;
        right: 13%;
    }

    .hsg-eye-normal-label {
        left: 30.3%;
    }
    .hsg-eye-need-attention-label {
        right: 26%;
        top: -30px;
    }
    .hsg-optometry-normal-img {
        left: 15.5%;
    }
    .hsg-optometry-attention-img {
        right: 6%;
    }
    .hsg-image {
        position: relative;
        left: 8.5%;
    }
    .hsg-image-big {
        position: relative;
        left: 7%;
    }
    .best-performance {
        position: relative;
        right: 12%;
    }
    .hsg-bar-line {
        width: 267px;
        right: 28%;
    }

    .hsg-clinical-normal-value {
        left: 7.3%;
    }

    .hsg-test {
        position: relative;
        left: 7%;
    }

    .hsg-image-main {
        position: relative;
        left: 7%;
    }
}


@media screen and (min-width: 1300px) and (max-width: 1500px) {
  
    
    .style-4 {
        right: 10.5%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date {
        right: 10.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 49%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5% ;
    }

    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 4%;
    }

    .hsg-eye-graph > img {
        position: relative;
        right: -17%;
    }

    .hsg-clinical-attention-value {
        position: relative;
        right: 12%;
    }

    .hsg-clinical-attention-label {
        position: relative;
        right: 13%;
    }

    .hsg-eye-normal-label {
        left: 30.6%;
    }
    .hsg-eye-need-attention-label {
        right: 22.3%;
        top: -30px;
    }
    .hsg-optometry-normal-img {
        left: 16.5%;
    }
    .hsg-optometry-attention-img {
        right: 2%;
    }
    .hsg-image {
        position: relative;
        left: 15%;
    }

    .best-performance {
        position: relative;
        right: 12%;
    }
    .hsg-bar-line {
        width: 335px;
        right: 28%;
    }

    .hsg-clinical-normal-value {
        left: 11.2%;
    }

    .hsg-test {
        position: relative;
        left: 11%;
    }
    .hsg-image-big {
        position: relative;
        left: 10%;
    }
    .hsg-image-main {
        position: relative;
        left: 10%;
    }
    .hsg-ent-ticks-2 {
        position: relative;
        bottom: 5px;
    }
}


@media screen and (min-width: 1500px) and (max-width: 1700px) {

    
    .style-4 {
        right: 12%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date {
        right: 12%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 63%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 4%;
    }

    .hsg-eye-graph > img {
        position: relative;
        right: -14%;
    }

    .hsg-clinical-attention-value {
        position: relative;
        right: 16%;
    }

    .hsg-clinical-attention-label {
        position: relative;
        right: 17%;
    }

    .hsg-eye-normal-label {
        left: 32%;
    }
    .hsg-eye-need-attention-label {
        right: 26.5%;
        top: -30px;
    }
    .hsg-optometry-normal-img {
        left: 18%;
    }
    .hsg-optometry-attention-img {
        right: 5%;
    }
    .hsg-image {
        position: relative;
        left: 17%;
    }
    .hsg-image-big {
        position: relative;
        left: 10%;
    }
    .best-performance {
        position: relative;
        right: 12%;
    }
    .hsg-bar-line {
        width: 360px;
        right: 29%;
    }

    .hsg-clinical-normal-value {
        left: 10.5%;
    }

    .hsg-test {
        position: relative;
        left: 10%;
    }

    .hsg-image-main {
        position: relative;
        left: 10%;
    }
}

@media screen and (min-width: 1700px) {

    
    .style-4 {
        right: 12.5%;
        position: relative;
    }
    
    .hsg-eye-report-header, .hsg-assessment-date {
        right: 12.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 185px;    
    }

    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative; 
        bottom: 60px;
        right: 4%;
    }

    .hsg-eye-graph > img {
        position: relative;
        right: -24%;
    }

    .hsg-clinical-attention-value {
        position: relative;
        right: 15%;
    }

    .hsg-clinical-attention-label {
        position: relative;
        right: 16%;
    }

    .hsg-eye-normal-label {
        left: 33%;
    }
    .hsg-eye-need-attention-label {
        right: 30%;
        top: -30px;
    }
    .hsg-image-big {
        position: relative;
        left: 10%;
    }
    .hsg-optometry-normal-img {
        left: 19.5%;
    }
    .hsg-optometry-attention-img {
        right: 7.5%;
    }
    .hsg-image {
        position: relative;
        left: 21%;
    }

    .best-performance {
        position: relative;
        right: 13%;
    }
    .hsg-bar-line {
        width: 405px;
        right: 29%;
    }

    .hsg-clinical-normal-value {
        left: 15%;
    }

    .hsg-test {
        position: relative;
        left: 15%;
    }
    .hsg-image-main {
        position: relative;
        left: 11%;
    }
}

</style>`;

const reportStyleGrowth = `<style>
.hsg-rx-bg {
    bottom: 0px; // 123px;
    height: 163px;
}

.hsg-growth-ticks-1, .hsg-growth-ticks-2 {
    text-align: center;
}

.rx-image {
    text-align: right;
}
.style-2 {
    width: 85px !important;
    height: 37px !important;
}

.style-3 {
    width: 67px !important;
    height: 30px !important;
}

.hsg-growth-report {
    bottom: 9px;
    top: 1px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-bg > img {
    position: relative;
    width: 100%;
    bottom: 170px;
    height: 156px;
    z-index: -1;
}

.hsg-checkup {
    position: relative;
    bottom: 8px;
    color: #6e6e6e !important;
    font-size: 12px !important;
    font-family: "font", sans-serif !important;
}

.hsg-growth-school-info {
    font-family: "fontBold", sans-serif !important;
    font-size: 18px !important;
}

.hsg-assessment-date {
    position: relative;
    bottom: 5px;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4  {
    font-size: 13px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-text-1, .hsg-footer-text-2 {
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-image-1, .hsg-image-2, .hsg-image-3, .hsg-image-4 {
    text-align: right;
    margin-right: 30px;
}

@media screen and (min-width: 750px) and (max-width: 900px){
  
    .style-4 {
        right: 6.3%;
        position: relative;
    }
    
    .hsg-growth-report, .hsg-assessment-date {
        right: 6%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 30%;
    }

}


@media screen and (min-width: 900px) and (max-width: 1100px) {
    .hsg-bar-1, .hsg-bar-2, .hsg-bar-3, .hsg-bar-4, .hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4, .hsg-growth-label-1, .hsg-growth-label-2, .hsg-growth-label-3, .hsg-growth-label-4, .style-16, .style-20 {
        position: relative;
       // right: 2%;
    }
    
    .style-4 {
        right: 8%;
        position: relative;
    }
    
    .hsg-growth-report {
        right: 9%;
        bottom: 9px;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 30%;
    }

}


@media screen and (min-width: 1100px) and (max-width: 1300px) {
    .hsg-bar-1, .hsg-bar-2, .hsg-bar-3, .hsg-bar-4, .hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4, .hsg-growth-label-1, .hsg-growth-label-2, .hsg-growth-label-3, .hsg-growth-label-4, .style-16, .style-20 {
        position: relative;
      //  right: 6%;
    }
    
    .style-4 {
        right: 10.5%;
        position: relative;
    }
    
    .hsg-growth-report, .hsg-assessment-date {
        right: 11.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }

}


@media screen and (min-width: 1300px) and (max-width: 1500px) {
    .hsg-bar-1, .hsg-bar-2, .hsg-bar-3, .hsg-bar-4, .hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4, .hsg-growth-label-1, .hsg-growth-label-2, .hsg-growth-label-3, .hsg-growth-label-4, .style-16, .style-20 {
        position: relative;
       // right: 8%;
    }
    
    .style-4 {
        right: 11.5%;
        position: relative;
    }
    
    .hsg-growth-report, .hsg-assessment-date {
        right: 12.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }

}


@media screen and (min-width: 1500px) and (max-width: 1700px) {

    .hsg-bar-1, .hsg-bar-2, .hsg-bar-3, .hsg-bar-4, .hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4, .hsg-growth-label-1, .hsg-growth-label-2, .hsg-growth-label-3, .hsg-growth-label-4, .style-16, .style-20 {
        position: relative;
      //  right: 9%;
    }
    
    .style-4 {
        right: 12%;
        position: relative;
    }
    
    .hsg-growth-report, .hsg-assessment-date {
        right: 13%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 62%;
    }
}

@media screen and (min-width: 1700px) {

    .hsg-bar-1, .hsg-bar-2, .hsg-bar-3, .hsg-bar-4, .hsg-growth-result-1, .hsg-growth-result-2, .hsg-growth-result-3, .hsg-growth-result-4, .hsg-growth-label-1, .hsg-growth-label-2, .hsg-growth-label-3, .hsg-growth-label-4, .style-16, .style-20 {
        position: relative;
     //   right: 11%;
    }
    
    .style-4 {
        right: 13%;
        position: relative;
    }
    
    .hsg-growth-report, .hsg-assessment-date {
        right: 14%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 156px;
    }
}

</style>`;

const reportStylePhysical = `<style>

.hsg-physical-school-info {
    font-size: 18px !important;
    font-family: "fontBold", sans-serif !important;
}

.hsg-ent-ticks-1, .hsg-ent-ticks-2, .hsg-ent-ticks-3 {
    text-align: center;
}

.hsg-rx-bg {
    bottom: 0px; // 133px;
    height: 200px;
}

.rx-image {
    text-align: right;
}

.hsg-bar-underline {

}

.hsg-ent-ticks-2 {
    
}

.hsg-checkup > span {
    position: relative;
    bottom: 8px;
    color: #6e6e6e !important;
    font-size: 12px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-bg > img {
    position: relative;
    width: 100%;
    bottom: 196px;

    z-index: -1;
}

.hsg-assessment-date {
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
    bottom: 5px;
}

.hsg-footer-header {
    font-size: 16px !important;
    font-family: "font", sans-serif !important;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3{
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-footer-text-3, .hsg-ent-ticks-3 > img {
    position: relative;
    bottom: 8px;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3 {
    vertical-align: top;
}

@media screen and (min-width: 1450px) {
    .hsg-ent-ticks-1 > img, .hsg-ent-ticks-2 > img, .hsg-ent-ticks-3     > img {
        position: relative;
        bottom: 4px;
      //  top: 7px;
    }
}

.hsg-overall-normal-value, .hsg-overall-attention-value, .hsg-physical-result-normal, .hsg-result-attention {
    font-size: 28px !important;
    font-weight: bold !important;
}

.hsg-physical-result-normal, .hsg-result-attention {
    position: relative;
    top: 8px;
}

.style-2 {
    width: 85px !important;
    height: 37px !important;
}

.hsg-physical-graph > img {
    width: 256px !important;
    height: 105px !important;
}

.best-performance  > img {
    width: 185px !important;
    height: 130px !important;
}

.style-3 {
    width: 67px !important;
    height: 30px !important;
}


.hsg-physical-report-header {
    bottom: 5px;
    position: relative;
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
}

.hsg-test-header, .hsg-test-header-top {
    font-size: 18px !important;
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-test-header-top {
    position: absolute;
}

// .hsg-physical-normal-bar, .hsg-physical-attention-bar {
//     background-repeat: repeat;
//     background-image: url(../../strip.png);
// }

.hsg-result, .hsg-result-attention-label {
    position: relative;
    bottom: 13px;
}

@media screen and (max-width: 900px){
  
    .style-4 {
        right: 6.3%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date {
        right: 6%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 30%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value {
        position: relative;
        right: 1.3%;
    }

    .hsg-overall-normal {
        bottom: 26px;
        left: 0.5%;
    }

    .hsg-overall-attention {
        position: relative;
        bottom: 20px;
        right: 5%;
    }

    .hsg-physical-graph > img {
        position: relative;
       
    }

    .hsg-result-attention, .hsg-result-attention-label {
        position: relative;
        
    }

    .best-performance {
        position: relative;
        right: 10%;
    }
    .hsg-bar-line {
        width: 170px;
        right: 30%;
    }
}


@media screen and (min-width: 900px) and (max-width: 1100px) {
  
    .style-4 {
        right: 8.5%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date {
        right: 9%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 30%;
    }
    .hsg-overall-normal-value, .hsg-overall-normal, .hsg-overall-attention-value{
        position: relative;
    }

    .hsg-overall-normal{
        position: relative;
        bottom: 26px;
       left: 0.5%;
    }  
    .hsg-overall-attention {
        position: relative;
        bottom: 20px;
        right: 5%;
    }
    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        right: 1%;
    }

    .hsg-physical-graph > img  {
        position: relative;
        right: -8%;
    }

    .hsg-test-image > img {
        position: relative;
        left: 36%;
    }

    .hsg-test-image-1 > img {
        position: relative;
        left: 36%;
    }

    .hsg-test-image-2 > img {
        position: relative;
        left: 44%;
    }

    .hsg-test-image-3 > img {
        position: relative;
        left: 27%;
    }

    .hsg-test-image-4 > img {
        position: relative;
        left: 26%;
    }

    .hsg-test-image-5 > img {
        position: relative;
        left: 30%;
    }

    .hsg-test-image-6 > img {
        position: relative;
        left: 44%;
    }
    .hsg-test-image-7 > img {
        position: relative;
        left: 71%;
    }
    .hsg-result-attention {
        position: relative;
        right: 4%;  
    }

    .hsg-result-attention-label {
        position: relative;
        right: 5%;   
    }

    .best-performance {
        position: relative;
        right: 10%;
    }
    .hsg-bar-line {
        width: 200px;
        right: 31%;
    }

    .hsg-physical-result-normal {
        left: 3.5%;
    }

    .hsg-result {
        position: relative;
        left: 4%;
    }
}

@media screen and (min-width: 1100px) and (max-width: 1300px) {
 
    .style-4 {
        right: 10.5%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date{
        right: 10.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }
    .hsg-overall-normal-value {
        position: relative;
        left: 0px;
    }

    .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-normal {
        position: relative;
        bottom: 26px;
        left: 1%;
    }

    .hsg-overall-attention {
        position: relative;
        bottom: 20px;
        right: 5.5%;
    }
    .hsg-overall-normal-value {
        position: relative;
        right: 3%;
    }

    .hsg-overall-attention-value {
        position: relative;
        right: 3%;
    }

    .hsg-physical-graph > img  {
        position: relative;
        right: -4%;
    }

    .hsg-test-image > img {
        position: relative;
        left: 42%;
    }

    .hsg-test-image-1 > img {
        position: relative;
        left: 36%;
    }

    .hsg-test-image-2 > img {
        position: relative;
        left: 44%;
    }

    .hsg-test-image-3 > img {
        position: relative;
        left: 33%;
    }

    .hsg-test-image-4 > img {
        position: relative;
        left: 33%;
    }

    .hsg-test-image-5 > img {
        position: relative;
        left: 35%;
    }

    .hsg-test-image-6 > img {
        position: relative;
        left: 46%;
    }
    .hsg-test-image-7 > img {
        position: relative;
        left: 78%;
    }
    .hsg-image-bg > img {
        position: relative;
        left: 34%;
    }
    .hsg-result-attention {
        position: relative;
        right: 11%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 12%;
    }

    .best-performance {
        position: relative;
        right: 13%;
    }
    .hsg-bar-line {
        width: 250px;
        right: 31%;
    }

    .hsg-physical-result-normal {
        left: 4%;
    }

    .hsg-result {
        position: relative;
        left: 5%;
    }
}


@media screen and (min-width: 1300px) and (max-width: 1500px) {
  
    
    .style-4 {
        right: 11.5%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date {
        right: 11.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 48%;
    }
    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-normal {
        position: relative;
        bottom: 26px;
        left: 1%;
    }

    .hsg-overall-attention{
        position: relative;
        bottom: 20px;
        right: 5.5%;
    }

    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        right: 2%;
    }

    .hsg-physical-graph > img  {
        position: relative;
        right: -6%;
    }

    .hsg-test-image > img {
        position: relative;
        left: 76%;
    }

    .hsg-test-image-1 > img {
        position: relative;
        left: 66%;
    }

    .hsg-test-image-2 > img {
        position: relative;
        left: 73%;
    }

    .hsg-test-image-3 > img {
        position: relative;
        left: 53%;
    }

    .hsg-test-image-4 > img {
        position: relative;
        left: 53%;
    }

    .hsg-test-image-5 > img {
        position: relative;
        left: 56%;
    }

    .hsg-test-image-6 > img {
        position: relative;
        left: 67%;
    }
    .hsg-test-image-7 > img {
        position: relative;
        left: 103%;
    }
    .hsg-image-bg > img {
        position: relative;
        left: 42%;
    }
    .hsg-result-attention {
        position: relative;
        right: 13%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 14%;
    }

    .best-performance {
        position: relative;
        right: 16%;
    }
    .hsg-bar-line {
        width: 330px;
        right: 30%;
    }

    .hsg-physical-result-normal {
        left: 6%;
    }

    .hsg-result {
        position: relative;
        left: 7%;
    }
}


@media screen and (min-width: 1500px) and (max-width: 1700px) {

    
    .style-4 {
        right: 12%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date {
        right: 12%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 62%;
    }
    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        left: 0.5%;
    }

    .hsg-overall-normal {
        position: relative;
        bottom: 26px;
        left: 15px;
    }

    .hsg-overall-attention {
        position: relative;
        bottom: 20px;
        right: 5.5%;
    }

    .hsg-overall-normal-value, .hsg-overall-attention-value {
        position: relative;
        right: 1%;
    }

    .hsg-physical-graph > img  {
        position: relative;
        right: -15%;
    }
    .hsg-test-image > img {
        position: relative;
        left: 52%;
    }

    .hsg-image-bg > img {
        position: relative;
        left: 52%;
    }
    .hsg-test-image > img {
        position: relative;
        left: 105%;
    }

    .hsg-test-image-1 > img {
        position: relative;
        left: 91%;
    }

    .hsg-test-image-2 > img {
        position: relative;
        left: 102%;
    }

    .hsg-test-image-3 > img {
        position: relative;
        left: 75%;
    }

    .hsg-test-image-4 > img {
        position: relative;
        left: 77%;
    }

    .hsg-test-image-5 > img {
        position: relative;
        left: 80%;
    }

    .hsg-test-image-6 > img {
        position: relative;
        left: 89%;
    }
    .hsg-test-image-7 > img {
        position: relative;
        left: 132%;
    }
    .hsg-result-attention {
        position: relative;
        right: 14%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 15%;
    }

    .best-performance {
        position: relative;
        right: 15%;
    }

    .hsg-bar-line {
        width: 340px;
        right: 31%;
    }

    .hsg-physical-result-normal {
        left: 10%;
    }

    .hsg-result {
        position: relative;
        left: 11%;
    }
  
}

@media screen and (min-width: 1700px) {

    
    .style-4 {
        right: 13.2%;
        position: relative;
    }
    
    .hsg-physical-report-header, .hsg-assessment-date {
        right: 13.5%;
        position: relative;
    }
    
    .style-3 {
        position: relative;
        left: 156px;
    }

    .hsg-overall-normal-value {
        position: relative;
        left: 8px;
    }

    .hsg-overall-attention-value {
        position: relative;
        left: 12px;
    }

    .hsg-overall-normal {
        position: relative;
        bottom: 26px;
        left: 19px;
    }

    .hsg-overall-attention {
        position: relative;
        bottom: 20px;
        right: 5.5%;
    }

    .hsg-physical-graph > img {
        position: relative;
        right: -21%;
    }

    .hsg-test-image > img {
        position: relative;
        left: 122%;
    }

    .hsg-test-image-1 > img {
        position: relative;
        left: 107%;
    }

    .hsg-test-image-2 > img {
        position: relative;
        left: 114%;
    }

    .hsg-test-image-3 > img {
        position: relative;
        left: 87%;
    }

    .hsg-test-image-4 > img {
        position: relative;
        left: 86%;
    }

    .hsg-test-image-5 > img {
        position: relative;
        left: 86%;
    }

    .hsg-test-image-6 > img {
        position: relative;
        left: 95%;
    }
    .hsg-test-image-7 > img {
        position: relative;
        left: 140%;
    }

    .hsg-image-bg > img {
        position: relative;
        left: 52%;
    }

    .best-performance {
        position: relative;
        right: 15%;
    }

    .hsg-result-attention {
        position: relative;
        right: 14%;
    }

    .hsg-result-attention-label {
        position: relative;
        right: 15%;
    }

    .hsg-physical-result-normal {
        left: 12.5%;
    }

    .hsg-result {
        position: relative;
        left: 13%;
    }

    .hsg-footer-text-1 {
        position: relative;
        bottom: 6px;
    }
    .hsg-footer-text-2 {
        position: relative;
        bottom: 12px;
    }
    .hsg-ent-ticks-3 {
        position: relative;
        top: 2px;
    }
   
}

</style>`;

const reportStyleOverview = `<link href="https://fonts.googleapis.com/css?family=Exo+2" rel="stylesheet">
<style>

.hsg-health-header {
    text-align: center !important;
}

.style-2 {
    color: #625b53 !important;
}

.style-15 {
    text-transform: uppercase;
}

.hsg-male-normal, .hsg-male-attention, .hsg-female-normal, .hsg-female-attention {
    font-family: "Exo 2", sans-serif !important;
    font-weight: 700 !important;
    position: relative;
}

.hsg-male-normal-label, .hsg-male-attention-label, .hsg-female-normal-label, .hsg-female-attention-label {
    font-family: "Exo 2", sans-serif !important;
    font-weight: 600 !important;
    position: relative;
}
.hsg-healthiest-class-label, .hsg-unhealthiest-class-label, .hsg-low-asses-label, .hsg-high-asses-label  {
    font-family: "Exo 2", sans-serif !important;
    position: relative;
}

.hsg-healthiest-class, .hsg-unhealthiest-class, .hsg-low-asses, .hsg-high-asses  {
    font-family: "Exo 2", sans-serif !important;
    text-align: center !important;
    position: relative;
}
  
.hsg-school-bmi-uw-value, .hsg-school-bmi-normal-value, .hsg-school-bmi-ow-value, .hsg-school-bmi-obese-value {
    color: #ffffff !important;
    position: relative;
    bottom: 132px;
    font-family: "Exo 2", sans-serif !important;
    
}

.hsg-school-bmi-uw, .hsg-school-bmi-normal, .hsg-school-bmi-ow, .hsg-school-bmi-obese {
    color: #ffffff !important;
    position: relative;
    bottom: 91px;
    font-size: 12px !important;
    font-family: "Exo 2", sans-serif !important;
}

.hsg-hygiene-normal-value, .hsg-hygiene-attention-value  {
    color: #ffffff !important;
    position: relative;
    bottom: 80px;
    font-family: "Exo 2", sans-serif !important;
}

.hsg-hygiene-normal, .hsg-hygiene-attention  {
    color: #ffffff !important;
    position: relative;
    bottom: 80px;
    font-family: "Exo 2", sans-serif !important;
    
}

.hsg-best-perf-label, .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-healthiest-param-label {
    
    position: relative;
}

.hsg-best-perf, .hsg-low-performing, .hsg-unhealthiest-param, .hsg-healthiest-param {
    
    position: relative;
}


@media screen and (min-width: 1024px) {

    .style-2 {
        color: #625b53 !important;
        font-size: 20px !important;
    }
    
    .style-3 {
        font-size: 20px !important;
        font-weight: bold !important;
        font-family: "Exo 2", sans-serif !important;
    }
    
    .hsg-hygiene-image > img {
        width: 480px !important;
        height: 200px !important;
    }
    
    .hsg-bmi-image > img {
        width: 460px !important;
        height: 190px !important;
    }

    .hsg-class-overview-image > img {
        width: 340px !important;
        height: 135px !important;
    }

    
    .hsg-male-normal, .hsg-male-attention, .hsg-female-normal, .hsg-female-attention {
        font-size: 36px !important;
        font-family: "Exo 2", sans-serif !important;
        position: relative;
        font-weight: 600 !important;
    }
    
    .hsg-male-normal-label, .hsg-male-attention-label, .hsg-female-normal-label, .hsg-female-attention-label {
        font-size: 14px !important;
        font-family: "Exo 2", sans-serif !important;
        position: relative;
        font-weight: 600 !important;
    }
    .hsg-healthiest-class-label, .hsg-unhealthiest-class-label, .hsg-low-asses-label, .hsg-high-asses-label  {
        font-size: 14px !important;
        position: relative;
        bottom: 9px;
    }
    
    .hsg-low-asses, .hsg-high-asses  {
        font-size: 14px !important;
        text-align: center !important;
        position: relative;
        bottom: 8px;
    }

    .hsg-healthiest-class, .hsg-unhealthiest-class {
        font-size: 14px !important;
        text-align: center !important;
        position: relative;
        bottom: 29px;
    }
      
    .hsg-school-bmi-uw-value, .hsg-school-bmi-normal-value, .hsg-school-bmi-ow-value, .hsg-school-bmi-obese-value {
        color: #ffffff !important;
        position: relative;
        bottom: 180px;
        font-size: 28px !important;
    }
    
    .hsg-school-bmi-uw, .hsg-school-bmi-normal, .hsg-school-bmi-ow, .hsg-school-bmi-obese {
        color: #ffffff !important;
        position: relative;
        bottom: 118px;
        font-size: 15px !important;
    }
    
    .hsg-hygiene-normal-value, .hsg-hygiene-attention-value  {
        color: #ffffff !important;
        position: relative;
        font-size: 22px !important;
        bottom: 99px;
        font-family: "Exo 2", sans-serif !important;
    }
    
    .hsg-hygiene-normal, .hsg-hygiene-attention  {
        color: #ffffff !important;
        position: relative;
        bottom: 103px;
        font-size: 12px !important;
        font-family: "Exo 2", sans-serif !important;
    }
    
    .hsg-best-perf-label, .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-healthiest-param-label {
        font-size: 16px !important;
        position: relative;
        font-family: "Exo 2", sans-serif !important;
    }
    
    .hsg-best-perf, .hsg-low-performing, .hsg-unhealthiest-param, .hsg-healthiest-param {
        font-size: 16px !important;
        position: relative;
       
    }
    .hsg-slash > img {
        width: 92px !important;
        height: 315px !important;
    }
}


@media screen and (min-width: 1100px) {
    .style-17 {
        width: 320px;
        height: 85px;
    }
}


@media screen and (max-width: 900px) {

    .hsg-school-bmi-uw-value { 
        left: 3%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        left: 1%;
    }
    
    .hsg-school-bmi-normal {
       
    }
    
    .hsg-school-bmi-ow-value {
        left: 2%;
    } 
    
    .hsg-school-bmi-ow {
        right: 0.5%;
    }
    
    .hsg-school-bmi-obese-value {
        left: 1%;
    }

    .hsg-school-bmi-obese {
       
    }

    .hsg-hygiene-normal-value {
        left: 3.5%;
    }
    
    .hsg-hygiene-normal {
        left: 3.2%;
    }
    
    .hsg-hygiene-attention {
      
    } 
    
    .hsg-hygiene-attention-value {
       
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
        position: relative;
        left: 2%;
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        position: relative;
        left: 2%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 8%;
    }

    .hsg-unhealthiest-class-label {
        right: 5%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 7%;
    }

    .hsg-low-asses-label {
        right: 5%;
    }

    .hsg-male-img > img {
       
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {

    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 3%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 2%;
    }
   
}

@media screen and (min-width: 900px) and (max-width: 1024px ) {

    .hsg-school-bmi-uw-value { 
        left: 3%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        left: 1%;
    }
    
    .hsg-school-bmi-normal {
       
    }
    
    .hsg-school-bmi-ow-value {
        
    } 
    
    .hsg-school-bmi-ow {
        right: 2%;
    }
    
    .hsg-school-bmi-obese-value {
        right: 1.5%;
    }

    .hsg-school-bmi-obese {
        right: 2.4%;
    }

    .hsg-hygiene-normal-value {
        left: 3.5%;
    }
    
    .hsg-hygiene-normal {
        left: 2.2%;
    }
    
    .hsg-hygiene-attention {
        right: 2%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 1%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
        position: relative;
        left: 2%;
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        position: relative;
        left: 2%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 8%;
    }

    .hsg-unhealthiest-class-label {
        right: 5%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 7%;
    }

    .hsg-low-asses-label {
        right: 5%;
    }

    .hsg-male-img > img {
        position: relative;
        right: 21%;
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {

    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 3%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 2%;
    }
   
}

@media screen and (min-width: 1024px) and (max-width: 1080px ) {

    .hsg-school-bmi-uw-value { 
        left: 2%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        left: 2.5%;
    }
    
    .hsg-school-bmi-normal {
        left: 3%;
    }
    
    .hsg-school-bmi-ow-value {
        left: 4.2%;
    } 
    
    .hsg-school-bmi-ow {
        left: 3.5%; 
    }
    
    .hsg-school-bmi-obese-value {
       left: 6.5%;
    }

    .hsg-school-bmi-obese {
       left: 6%;
    }

    .hsg-hygiene-normal-value {
        left: 2.5%;
    }
    
    .hsg-hygiene-normal {
        left: 2%;
    }
    
    .hsg-hygiene-attention {
        left: 1%;
    } 
    
    .hsg-hygiene-attention-value {
        left: 0.5%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
      
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        left: 1%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 3%;
    }

    .hsg-unhealthiest-class-label {
        right: 1%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 2%;
    }

    .hsg-low-asses-label {
        right: 2%;
    }

    .hsg-male-img > img {
        left: 1%;
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 3%;
    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 5%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 5%;
    }   
    .style-18 {
        position: relative;
        right: 17%;    
    }
    .hsg-children-2 {
        position: relative;
        right: 1.5%;    
        bottom: 12px;
    }
    .hsg-children-1 {
        position: relative; 
        bottom: 12px;
    }
}



@media screen and (min-width: 1080px) and (max-width: 1200px ) {

    .hsg-school-bmi-uw-value { 
        left: 2%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        left: 2.5%;
    }
    
    .hsg-school-bmi-normal {
        left: 2%;
    }
    
    .hsg-school-bmi-ow-value {
        left: 2.2%;
    } 
    
    .hsg-school-bmi-ow {
        left: 1.5%; 
    }
    
    .hsg-school-bmi-obese-value {
       left: 2.5%;
    }

    .hsg-school-bmi-obese {
       left: 3%;
    }

    .hsg-hygiene-normal-value {
        left: 2.5%;
    }
    
    .hsg-hygiene-normal {
        left: 2%;
    }
    
    .hsg-hygiene-attention {
        right: 1%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 1%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
      
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        left: 1%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 3%;
    }

    .hsg-unhealthiest-class-label {
        right: 1%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 2%;
    }

    .hsg-low-asses-label {
        right: 2%;
    }

    .hsg-male-img > img {
        left: 1%;
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 3%;
    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 5%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 5%;
    }   
    .style-18 {
        position: relative;
        right: 17%;    
    }
    .hsg-children-2 {
        position: relative;
        right: 1.5%;    
        bottom: 12px;
    }
    .hsg-children-1 {
        position: relative; 
        bottom: 12px;
    }

    .hsg-slash > img {
        position: relative;
        right: 77%;
    }
}




@media screen and (min-width: 1200px) and (max-width: 1350px ) {

    .hsg-school-bmi-uw-value { 
        left: 2%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        left: 1.3%;
    }
    
    .hsg-school-bmi-normal {
        left: 0.5%;
    }
    
    .hsg-school-bmi-ow-value {
        left: 1.2%;
    } 
    
    .hsg-school-bmi-ow {
        right: 0.3%;
    }
    
    .hsg-school-bmi-obese-value {
        left: 1%;
    }

    .hsg-school-bmi-obese {
    
    }

    .hsg-hygiene-normal-value {
        left: 2.5%;
    }
    
    .hsg-hygiene-normal {
        left: 2.2%;
    }
    
    .hsg-hygiene-attention {
        right: 3%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 2.5%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
      
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        left: 1%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 3%;
    }

    .hsg-unhealthiest-class-label {
        right: 1%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 2%;
    }

    .hsg-low-asses-label {
        right: 2%;
    }

    .hsg-male-img > img {
      
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 5%;
    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 7%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 8%;
    }   
  
    .hsg-children-2 {
        position: relative;
        right: 1.5%;    
        bottom: 12px;
    }
    .hsg-children-1 {
        position: relative; 
        bottom: 12px;
    }

    .hsg-slash > img {
        position: relative;
        right: 77%;
    }
}


@media screen and (min-width: 1350px) and (max-width: 1400px ) {

    .hsg-school-bmi-uw-value { 
        left: 1.5%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
       
    }
    
    .hsg-school-bmi-normal {
        right: 0%;
    }
    
    .hsg-school-bmi-ow-value {
        right: 1%;
    } 
    
    .hsg-school-bmi-ow {
        right: 2%;
    }
    
    .hsg-school-bmi-obese-value {
        right: 2%;
    }

    .hsg-school-bmi-obese {
        right: 2.5%;  
    }

    .hsg-hygiene-normal-value {
        left: 1.5%;
    }
    
    .hsg-hygiene-normal {
        left: 1.5%;
    }
    
    .hsg-hygiene-attention {
        right: 4%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 5%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
        right: 2.5%;
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        right: 2.5%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 6%;
    }

    .hsg-unhealthiest-class-label {
        right: 3%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 5%;
    }

    .hsg-low-asses-label {
        right: 3%;
    }

    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 6%;
    }
    .hsg-female-arrow-2 {
        
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 8%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 8    %;
    }

    .hsg-male-img > img{
        position: relative;
        right: 17%;    
    }
    .hsg-children-2 {
        position: relative;
        right: 5%;    
        bottom: 12px;
    }
    .hsg-children-1 {
        position: relative; 
        bottom: 12px;
    }

    .hsg-slash > img {
        position: relative;
        right: 77%;
    }
}


@media screen and (min-width: 1400px) and (max-width: 1700px ) {

    .hsg-school-bmi-uw-value { 
        left: 1.5%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        right: 1%;
    }
    
    .hsg-school-bmi-normal {
        right: 1.3%;
    }
    
    .hsg-school-bmi-ow-value {
        right: 2.5%;
    } 
    
    .hsg-school-bmi-ow {
        right: 4%;
    }
    
    .hsg-school-bmi-obese-value {
        right: 6.5%;
    }

    .hsg-school-bmi-obese {
        right: 6%;  
    }

    .hsg-hygiene-normal-value {
        left: 1.5%;
    }
    
    .hsg-hygiene-normal {
        left: 1.5%;
    }
    
    .hsg-hygiene-attention {
        right: 6%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 6%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
        right: 2.5%;
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        right: 2.5%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 6%;
    }

    .hsg-unhealthiest-class-label {
        right: 3%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 5%;
    }

    .hsg-low-asses-label {
        right: 3%;
    }

    .hsg-male-img > img {
        position: relative;
        right: 21%;
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 6%;
    }
    .hsg-female-arrow-2 {
        position: relative;
        left: 2%;
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-normal{
        position: relative;
        right: 8%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 8%;
    }

    .hsg-female-attention, hsg-female-attention-label {
        position: relative;
        left: 2%;
    }
  
    .hsg-children-2 {
        position: relative;
        right: 5%;    
        bottom: 12px;
    }
    .hsg-children-1 {
        position: relative; 
        bottom: 12px;
    }

    .hsg-slash > img {
        position: relative;
        right: 77%;
    }
}


@media screen and (min-width: 1700px) {

    .hsg-school-bmi-uw-value { 
        left: 1.5%;
    }
    
    .hsg-school-bmi-uw{
        left: 0.5%;
    } 
    
    .hsg-school-bmi-normal-value {
        right: 2.3%;
    }
    
    .hsg-school-bmi-normal {
        right: 2.3%;
    }
    
    .hsg-school-bmi-ow-value {
        right: 5%;
    } 
    
    .hsg-school-bmi-ow {
        right: 6%;
    }
    
    .hsg-school-bmi-obese-value {
        right: 8.3%;
    }

    .hsg-school-bmi-obese {
        right: 8.5%;
    }

    .hsg-hygiene-normal-value {
        left: 1.5%;
    }
    
    .hsg-hygiene-normal {
        left: 2%;
    }
    
    .hsg-hygiene-attention {
        right: 9%;
    } 
    
    .hsg-hygiene-attention-value {
        right: 9.5%;
    }

    .hsg-best-perf-label, .hsg-best-perf,  .hsg-healthiest-param-label, .hsg-healthiest-param {
        right: 4.5%;
    } 
    
    .hsg-low-performing-label, .hsg-unhealthiest-param-label, .hsg-low-performing, .hsg-unhealthiest-param {
        right: 3%;
    }

    .hsg-healthiest-class {
        right: 2%;
    }

    .hsg-unhealthiest-class {
        right: 8%;
    }

    .hsg-unhealthiest-class-label {
        right: 5%;
    }

    .hsg-high-asses {
        right: 2%;
    }

    .hsg-low-asses {
        right: 7%;
    }

    .hsg-low-asses-label {
        right: 5%;
    }

    .hsg-male-img > img {
        position: relative;
        right: 21%;
    }
    .hsg-female-img > img {

    }
    .hsg-male-label {
        position: relative;
        right: 1%;
    }
    .hsg-female-label {

    }
    .hsg-female-arrow-1 {
        position: relative;
        right: 8%;
    }
    .hsg-female-arrow-2 {
        position: relative;
        left: 4%;
    }
    .hsg-male-arrow-1 {
        
    }
    .hsg-male-arrow-2 {
        
    }

    .hsg-female-attention, hsg-female-attention-label {
        position: relative;
        left: 2%;
    }

    .hsg-female-normal{
        position: relative;
        right: 12%
    }

    .hsg-female-normal-label  {
        position: relative;
        right: 12%;
    }
    .style-18 { 
        position: relative;
        right: 17%;    
    }
    .hsg-children-2 {
        position: relative;
        right: 12%;    
    }

    .hsg-slash > img {
        position: relative;
        right: 77%;
    }

}



</style>`;

const reportStyleClassMap = {
  dental: reportStyleDental,
  ent: reportStyleENT,
  eye: reportStyleEye,
  growth: reportStyleGrowth,
  physical: reportStylePhysical,
  schoolOverView: reportStyleOverview,
};

const reportsStudentStyles = `<style>

.hsg-rx-logo {
    text-align: right;
}

body {
    background-image: url('../../../bg.png');
    background-repeat: repeat;
}

td {
    padding:0 !important; margin:0;
 }

 @font-face {
    font-family: "fontBold";
    src: url("../../../Fonts/hinted-MyriadSetPro-Bold.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Bold.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Bold.eot") format("eot");
    }

@font-face {
    font-family: "fontMedium";
    src: url("../../../Fonts/hinted-MyriadSetPro-Medium.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Medium.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Medium.eot") format("eot");
    }
@font-face {
    font-family: "fontSemibold";
    src: url("../../../Fonts/hinted-MyriadSetPro-Semibold.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Semibold.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Semibold.eot") format("eot");
    }
@font-face {
    font-family: "fontUltralight";
    src: url("../../../Fonts/hinted-MyriadSetPro-Ultralight.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Ultralight.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Ultralight.eot") format("eot");
    }

@font-face {
    font-family: "fontThin";
    src: url("../../../Fonts/hinted-MyriadSetPro-Thin.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Thin.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Thin.eot") format("eot");
    }

@font-face {
    font-family: "font";
    src: url("../../../Fonts/hinted-MyriadSetPro-Text.ttf");
    src: url("../../../Fonts/hinted-MyriadSetPro-Text.woff") format("woff"),
        url("../../../Fonts/hinted-MyriadSetPro-Text.eot") format("eot");
    }
    
 body {
    margin: 0px !important;
    font-family: font !important;
 }

 table {
    font-family: font !important;
 }

.hsg-suggested {
    text-transform: uppercase !important;
}

.hsg-parent-cms {
    position: absolute;
    right: 1%;
    top: -4px;
    text-align: center;
    font-family: "font", sans-serif;
}

.hsg-parent-cms > p {
    color: #898989;
    text-transform: uppercase;
    font-size: 12px;
    margin-bottom: 4px;
    font-family: "font", sans-serif;
}

.hsg-report-download {
    position: absolute;
    right: 28px;
    top: 60px;
    color: grey;

}
  
.hsg-report-download-btn {
    text-transform: uppercase;
    margin-bottom: 10px;
    background: transparent;
    top: 21px;
    position: relative;
    border: 0px !important;
    font-family: "font",sans-serif;
    font-size: 11pt;
    color: grey;
    left: 10px;
    cursor: pointer;
    &:focus{
        border: 0px !important;
    }
}

.hsg-report-back-btn {
    display: inline-block;
    font-family: "fontBold" ,sans-serif;
    font-size: 11pt;
    color: grey;
    cursor: pointer;
    position: relative;
    top: 20px;
    font-weight: 600;
}

.hsg-test-input{
    text-transform: uppercase !important;
}
.hsg-ent-test-input{
    text-transform: uppercase !important;
}
.hsg-eye-test-input{
    text-transform: uppercase !important;
}
.hsg-physical-test-input{
    text-transform: uppercase !important;
}

.style-1 {
    position: relative;
}

.hsg-header-bar {
    position: relative;
    right: 8.5%;
    bottom: 10px;
}

.hsg-dmft-jaw-block {
    position: relative;
    top: 1300px;
    left: 35.5%;
    z-index: 9;
    width: 60%;
}

.hsg-report-download {
    z-index: 999;
}

.hsg-eye-bullets, .hsg-ent-bullets, .hsg-dental-bullets, .hsg-physical-bullets, .hsg-growth-bullets  {
    left: -4px;
    position: relative;
}

.hsg-physical-stud-info, .hsg-dental-stud-info, .hsg-eye-stud-info, .hsg-ent-stud-info {
    top: 6px;
    vertical-align: top;
    position: relative;
}

.hsg-vendor-logo > img {
    float: right;
    padding-right: 15%;
}

.list-RX {
    color: #fff;
    line-height: 24px;
    font-size: 13px;
    font-weight: 600;
}

.list-RX > li {
    color: #fff;
    line-height: 24px;
    font-size: 13px;
    font-weight: 600;
    background-image: url(../../../ico-tick.png);
    background-repeat: no-repeat;
    background-position: left 3px;
    padding-left: 25px;
    text-transform: uppercase;
}

ul, ol {
    margin: 0;
    padding: 0;
    list-style: none;
}

.sign-img {
    text-align: right;
}

.hsg-eye-footer-text-1 > span, .hsg-eye-footer-text-2 > span, .hsg-eye-footer-text-3 > span, .hsg-growth-footer-text-1 > span, .hsg-growth-footer-text-2 > span, .hsg-growth-footer-text-3 > span {
    margin-left: 3px;
}

</style>`;

const reportStyleStudentPhysical = `<style>

.test-img, .test-img-last, .test-img-3,  .test-img-1 {
    text-align: right;
}

.test-img-1 > img , .test-img-3 > img {
    width: 183px !important;
    height: 144px !important;
}

.hsg-rx {
    position: absolute;
    left: 100px;
    top: 4192px;
}

// @media screen and (max-height: 400px)  {
//     .hsg-rx {
//         position: absolute;
//         left: 100px;
//        top: 4192px; // top: 4209px;
//     }
// }

// @media screen and (max-height: 500px) and (min-height: 200px) {
//     .hsg-rx {
//         position: absolute;
//         left: 100px;
//        top: 4192px; // top: 4209px;
//     }
// }

// @media screen and (max-height: 500px) and (min-height: 200px) {
//     .hsg-rx {
//         position: absolute;
//         left: 100px;
//        top: 4192px; // top: 4209px;
//     }
// }

.hsg-physical-instruct-tick-1 > img {
    position: relative;
    top: 3px;
}

.hsg-physical-instruct-tick-3 > img {
    position: relative;
    bottom: 7px;
}

.hsg-physical-footer-text-2 > span {
    position: relative;
    bottom: 11px;
}

.hsg-physical-footer-text-3 > span {
    position: relative;
    bottom: 20px;
}

.hsg-physical-instruct-tick-3 > img {
    position: relative;
    top: 13px;
}

.style-42 > img {

}

.style-33 {
    font-size: 13px !important;
    color: #333333 !important;
    text-transform: uppercase !important;
}
.style-14 {
    font-size: 15px !important;
    font-family: "font", sans-serif  !important;
}

.hsg-physical-doctor {
    font-size: 16px !important;
    color: #333333 !important;
    bottom: 5px;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif  !important;
}

.hsg-dotor-details {
    font-family: "font", sans-serif  !important;
    position: relative;
}

.hsg-physical-stud-info {
    color: #333333 !important;
    font-size: 13px !important;
    font-family: "font", sans-serif  !important;
}

.hsg-physical-report-header {
    color: #333333 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}
.hsg-assessment-date {
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-physical-test-header {
    font-size: 16px !important;
    font-family: "fontBold", sans-serif  !important;
}

.hsg-physical-header-status-1, .hsg-physical-header-status-2 {
    color: #333333 !important;
    font-family: "font", sans-serif  !important;
    font-size: 14px !Important;
    top: 5px;
} 

.hsg-physical-header-status-icon-1 > img {
    position: relative;
    top: 5px;
}
.hsg-physical-header-status-icon-2 > img {
    position: relative;
    top: 5px;
}

.hsg-physical-footer-text-1, .hsg-physical-footer-text-2, .hsg-physical-footer-text-3 {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
    color: #ffffff !important;
}

.hsg-single-test-msg {
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-physical-test-input {
    font-family: "fontSemibold", sans-serif  !important;
    position: relative;
}

.hsg-suggested-remarks {
    font-family: "fontSemibold", sans-serif  !important;
    position: relative;
    font-size: 16px !important;
    color: #333333 !important;
}

.hsg-suggested {
    font-family: "fontSemibold", sans-serif  !important;
    border-radius: 30px;
}

.hsg-footer-header {
    font-family: "fontBold", sans-serif !important;
    font-size: 16px !important;
}

@media screen and (max-width: 800px) {
    .hsg-report-download {
        top: 112px;
        position: relative;
        float: right;
        right: 0px;
    }
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-physical-header-status-1 {
        position: relative;
       
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-physical-header-status-2 {
        position: relative;
       
    }
    .hsg-physical-report-header , .hsg-assessment-date{
        position: relative;
        right: -1%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: -3.5%;
    }
    .hsg-dotor-details {
        right: -3.5%;
    }
    .hsg-header-bar {
        right: 0%;
        top: 4px;
    }
    .hsg-physical-test-input {
        padding-left: 10px;
    } 
   
}

@media screen and (min-width: 800px) and (max-width: 880px){
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
      
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-physical-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 1.5%;
    }
    .hsg-dotor-details {
        right: 1.5%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 3.5%;
    }
    .hsg-header-bar {
        right: 4%;
        top: 4px;
    }

}

@media screen and (min-width: 880px) and (max-width: 1023px){
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
       
    }
    .hsg-physical-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 3.5%;
    }
    .hsg-dotor-details {
        right: 3.5%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 3%;
    }
    .hsg-header-bar {
        right: 4.5%;
        top: 4px;
    }

}

@media screen and (min-width: 1023px) and (max-width: 1290px){
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        left: 50px;
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 5%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        left: 40px;
    }
    .hsg-physical-header-status-2 {
        position: relative;
        left: 4%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 5.5%;
    }
    .hsg-dotor-details {
        right: 5.5%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 5%;
    }
    .hsg-header-bar {
        right: 5.5%;
        top: 4px;
    }
}

@media screen and (min-width: 1290px) and (max-width: 1500px){
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        left: 60px;
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 4.5%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        left: 70px;
    }
    .hsg-physical-header-status-2 {
        position: relative;
       left: 5%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 7.5%;
    }
    .hsg-header-bar {
        right: 7.9%;
        top: 4px;
    }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        left: 217px;
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 14%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        left: 160px;
    }
    .hsg-physical-header-status-2 {
        position: relative;
        left: 10%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 8%;
    }
    .hsg-dotor-details {
        right: 8%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 7.5%;
    }
    .hsg-header-bar {
        right: 8.5%;
        top: 4px;
    }
}

@media screen and (min-width: 1700px) {
    .hsg-physical-header-status-icon-1 > img {
        position: relative;
        left: 320px;
    }
    .hsg-physical-header-status-1 {
        position: relative;
        left: 17%;
    }
    .hsg-physical-header-status-icon-2 > img {
        position: relative;
        left: 210px;
    }
    .hsg-physical-header-status-2 {
        position: relative;
        left: 11%;
    }
    .hsg-physical-doctor {
        position: relative;
        right: 9%;
    }
    .hsg-dotor-details {
        right: 9%;
    }
    .hsg-physical-report-header, .hsg-assessment-date {
        position: relative;
        right: 9%;
    }
    .hsg-header-bar {
        right: 9.5%;
        top: 4px;
    }
    .hsg-physical-test-input, .test-icon {

    }
}
</style>`;

const reportStyleStudentEye = `<style>

.hsg-optometry {
    position: absolute;
    top: 310px;
    width: 100%;
    left: 0%;
    text-align: center;
}

.left-eye-block {
    position: relative;
    display: inline-block;
    padding-right: 100px;
}

.right-eye-block {
   position: relative;
   display: inline-block;
   padding-left: 100px;
}

.left-eye, .right-eye {
    background-color: #55bc6e;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    line-height: 70px;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    color: white;
}

.vision-title {
    color: #5a357c;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 20px;
  
}

.test-img {
    text-align: right;
}

.hsg-rx {
    position: absolute;
    left: 100px;
    top: 1648px;
}

.hsg-img-big > img {
    width: 700px !important;
    height: 256px !important;
}

.hsg-img-big {
    top: 2px;
}

.hsg-eye-footer-text-1 > span {

}

.hsg-eye-instruct-ticks-1 > img {
    position: relative;
    top: 11px;
}

.hsg-eye-footer-text-2 > span {
    position: relative;
    bottom: 6px;
}

.hsg-eye-footer-text-3 > span {
    position: relative;
    bottom: 15px;
}

.hsg-eye-vision-right-label, .hsg-eye-vision-left-label  {
    position: relative;
    bottom: 20px;
}

.hsg-eye-vision-right-icon, .hsg-eye-vision-left-icon {
    position: relative;
}

.style-1 {
    font-size: 13px !important;
    color: #333333 !important;
    text-transform: uppercase !important;
}

.hsg-eye-doctor {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif !important;
    bottom: 5px;
}

.hsg-eye-footer-text-1, .hsg-eye-footer-text-2, .hsg-eye-footer-text-3 {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
    color: #ffffff !important;
}


.hsg-eye-stud-info {
    color: #333333 !important;
    font-size: 13px !important;
    font-family: "font", sans-serif !important;
}

.hsg-eye-report-header {
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-assessment-date {
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-eye-header-status-1, .hsg-eye-header-status-2 {
    color: #333333 !important;
    position: relative;
    top: 5px;
    font-family: "font", sans-serif !important;
}

.hsg-eye-header-status-icon-1 > img {
    position: relative;
    top: 5px;
}
.hsg-eye-header-status-icon-2 > img {
    position: relative;
    top: 5px;
}

.hsg-eye-optometry {
    border-radius: 15px;
    font-family: "fontBold", sans-serif !important;
}

.hsg-eye-vision-left{
    position: relative;
    font-size: 27px !important;
    bottom: 14px;
    font-family: "font", sans-serif !important;
    font-size: 20px !important;
}

.hsg-eye-vision-left-label, .hsg-eye-vision-right-label {
    font-family: "font", sans-serif !important;
    font-size: 20px !important;
}

.hsg-eye-vision-right {
    position: relative;
    font-size: 27px !important;
    bottom: 14px;
    //bottom: 122px;
    font-family: "font", sans-serif !important;
    font-size: 20px !important;
}

.hsg-eye-test-header  {
    font-size: 13px !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif !important;
    font-size: 16px !important;
    left: -1%;
    position: relative;
}

.hsg-verify-header {
    font-family: "fontSemibold", sans-serif  !important;
    font-size: 18px !important;
}

.hsg-footer-header {
    font-family: "fontBold", sans-serif  !important;
    font-size: 16px !important;
}

.hsg-suggested {
    font-family: "fontSemibold", sans-serif  !important;
    border-radius: 30px;
}

.hsg-suggested-remarks {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 16px !important;
    color: #333333 !important;
}

.hsg-single-test-msg {
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-eye-test-input  {
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-dotor-details {
    font-family: "font", sans-serif  !important;
    position: relative;
}

@media screen and (max-width: 800px) {
    .hsg-eye-vision-left{
        left: 19.5%;
    }
    .hsg-eye-vision-right {
        left: 26%;
    }
    .hsg-report-download {
        top: 112px;
        position: relative;
        float: right;
        right: 0px;
    }
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-eye-header-status-1 {
        position: relative;
       
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-eye-header-status-2 {
        position: relative;
       
    }

    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: -1%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: -2.5%;
    }
    .hsg-dotor-details {
        right: -2.5%;
    }
    .hsg-header-bar {
        right: 0%;
        top: 4px;
    }
    .hsg-eye-test-input {
        padding-left: 10px;
    } 
   
}

@media screen and (min-width: 800px) and (max-width: 880px){
    .hsg-eye-vision-left{
        left: 17.5%;
    }
    .hsg-eye-vision-right {
        left: 11%;
    }
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
      
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-eye-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 5.5%;
    }
    .hsg-dotor-details {
        right:5.5%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 3.5%;
    }
    .hsg-header-bar {
        right: 4%;
        top: 4px;
    }

}

@media screen and (min-width: 880px) and (max-width: 1023px){
    .hsg-eye-vision-left{
        left: 15.5%;
    }
    .hsg-eye-vision-right {
        right: -5%;
    }
    .hsg-img-big {
        position: relative;
        
    }
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
       
    }
    .hsg-eye-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 0.5%;
    }
    .hsg-dotor-details {
        right: 0.5%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 3%;
    }
    .hsg-header-bar {
        right: 4.5%;
        top: 4px;
    }

}

@media screen and (min-width: 1023px) and (max-width: 1290px){
    .hsg-eye-vision-left{
        left: 13%;
    }

    .hsg-eye-vision-left-label {
       
    }

    .hsg-eye-vision-left-icon {
     
    }   

    .hsg-eye-vision-right {
        right: 22%;
    }
    .hsg-eye-vision-right-label {
        right: 6%;
    }

    .hsg-eye-vision-right-icon {
        right: 5%;
    }
    .hsg-img-big {
        position: relative;
        
    }
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        left: 20px;
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 2%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        right: 0px;
    }
    .hsg-eye-header-status-2 {
        position: relative;
        right: 0%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 5.5%;
    }
    .hsg-dotor-details {
        right: 5.5%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 6%;
    }
    .hsg-header-bar {
        right: 6.5%;
        top: 4px;
    }
}

@media screen and (min-width: 1290px) and (max-width: 1500px){
    .hsg-eye-vision-left{
        left: 12%;
    }

    .hsg-eye-vision-left-label {
        left: 6%;
    }

    .hsg-eye-vision-left-icon {
       left: 5%;
    }   

    .hsg-eye-vision-right {
        right: 25.5%;
    }
    .hsg-eye-vision-right-label {
        right: 15%;
    }
    .hsg-img-big {
        position: relative;
      
    }
    .hsg-eye-vision-right-icon {
        right: 13%;
    }   
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        left: 110px;
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 8.5%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        left: 50px;
    }
    .hsg-eye-header-status-2 {
        position: relative;
       left: 4%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 7.5%;
    }
    .hsg-header-bar {
        right: 8%;
        top: 4px;
    }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
    .hsg-eye-vision-left{
        left: 13.2%;
    }

    .hsg-eye-vision-left-label {
        left: 6%;
    }

    .hsg-eye-vision-left-icon {
       left: 5%;
    }   

    .hsg-eye-vision-right {
        right: 29%;
    }
    .hsg-eye-vision-right-label {
        right: 15%;
    }
    .hsg-img-big {
        position: relative;
        left: 1%;
    }
    .hsg-eye-vision-right-icon {
        right: 13%;
    }   
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        left: 190px;
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 13%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        left: 90px;
    }
    .hsg-eye-header-status-2 {
        position: relative;
        left: 6%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 8%;
    }
    .hsg-dotor-details {
        right: 8%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 8.5%;
    }
    .hsg-header-bar {
        right: 9%;
        top: 4px;
    }
}

@media screen and (min-width: 1700px) {
    .hsg-eye-vision-left{
        left: 18.1%;
    }

    .hsg-eye-vision-left-label {
        left: 6%;
    }
    .hsg-eye-vision-left-icon {
       left: 5%;
    }   

    .hsg-eye-vision-right {
        right: 19.5%;
    }
    .hsg-eye-vision-right-label {
        right: 18%;
    }
    .hsg-img-big {
        position: relative;
        left: 5%;
    }
    .hsg-eye-optometry {
        
       // position: relative;
       // left: 7%;
    }
    .hsg-eye-vision-right-icon {
        right: 16%;
    }   
    .hsg-eye-header-status-icon-1 > img {
        position: relative;
        left: 270px;
    }
    .hsg-eye-header-status-1 {
        position: relative;
        left: 15%;
    }
    .hsg-eye-header-status-icon-2 > img {
        position: relative;
        left: 160px;
    }
    .hsg-eye-header-status-2 {
        position: relative;
        left: 9%;
    }
    .hsg-eye-doctor {
        position: relative;
        right: 9%;
    }
    .hsg-dotor-details {
        right: 9%;
    }
    .hsg-eye-report-header, .hsg-assessment-date {
        position: relative;
        right: 9%;
    }
    .hsg-header-bar {
        right: 9.5%;
        top: 4px;
    }

   
}


}

</style>`;

const reportStyleStudentENT = `<style>

.test-img, .test-img-last {
    text-align: right;
}

.test-img-last > img {
    width: 187px !important;
    height: 145px !important;
}

.hsg-rx {
    position: absolute;
    left: 100px;
    top: 2057px;
}

.hsg-ent-instruct-tick-1 > img {
    position: relative;
    top: 17px;
}

.hsg-ent-footer-text-2 > span {
    position: relative;
    bottom: 20px;
}

.hsg-ent-instruct-tick-3 > img {
    position: relative;
    bottom: 18px;
}

.hsg-ent-footer-text-3 > span {
    position: relative;
    bottom: 30px;
}

.hsg-ent-test-header  {
    font-size: 13px !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif !important;
    font-size: 16px !important;
}

.hsg-ent-test-input  {
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-ent-doctor {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif  !important;
    position: relative;
    bottom: 5px;
}

.hsg-dotor-details {
    font-family: "font", sans-serif  !important;
    position: relative;
}

.hsg-ent-header-status-1, .hsg-ent-header-status-2 {
    color: #333333 !important;
    font-family: "font", sans-serif  !important;
    font-size: 14px !important;
    top: 5px;
}

.hsg-ent-header-status-icon-1 > img {
    position: relative;
    top: 5px;
}
.hsg-ent-header-status-icon-2 > img {
    position: relative;
    top: 5px;
}

.hsg-ent-footer-text-1, .hsg-ent-footer-text-2, .hsg-ent-footer-text-3 {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
    color: #ffffff !important;
}

.hsg-ent-stud-info {
    color: #333333 !important;
    font-size: 13px !important;
    font-family: "font", sans-serif  !important;
}

.hsg-ent-report-header {
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-assessment-date {
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-verify-header {
    font-family: "fontSemibold", sans-serif  !important;
    font-size: 18px !important;
}

.hsg-footer-header {
    font-family: "fontBold", sans-serif  !important;
    font-size: 16px !important;
}

.hsg-suggested {
    font-family: "fontSemibold", sans-serif  !important;
    border-radius: 30px;
}

.hsg-suggested-remarks {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 16px !important;
}

.hsg-single-test-msg {
    font-family: "fontSemibold", sans-serif !important;
}

@media screen and (max-width: 800px) {
    .hsg-report-download {
        top: 112px;
        position: relative;
        float: right;
        right: 0px;
    }
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-ent-header-status-1 {
        position: relative;
       
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-ent-header-status-2 {
        position: relative;
       
    }
   
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: -1%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: -4.5%;
    }
    .hsg-dotor-details {
        right: -4.5%;
    }
    .hsg-header-bar {
        right: 0%;
        top: 4px;
    }
    .hsg-ent-test-input {
        padding-left: 10px;
    } 
   
}

@media screen and (min-width: 800px) and (max-width: 880px){
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
      
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        
    }
    .hsg-ent-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 5.5%;
    }
    .hsg-dotor-details {
        right: 5.5%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 3.5%;
    }
    .hsg-header-bar {
        right: 4%;
        top: 4px;
    }

}

@media screen and (min-width: 880px) and (max-width: 1023px){
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 1%;
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
       
    }
    .hsg-ent-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 3.5%;
    }
    .hsg-dotor-details {
        right: 3.5%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 3%;
    }
    .hsg-header-bar {
        right: 4.5%;
        top: 4px;
    }

}

@media screen and (min-width: 1023px) and (max-width: 1290px){
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        left: 40px;
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 4%;
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        right: 5px;
    }
    .hsg-ent-header-status-2 {
        position: relative;
        right: 0%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 5.5%;
    }
    .hsg-dotor-details {
        right: 5.5%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 6%;
    }
    .hsg-header-bar {
        right: 6.5%;
        top: 4px;
    }
}

@media screen and (min-width: 1290px) and (max-width: 1500px){
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        left: 120px;
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 9.5%;
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        left: 60px;
    }
    .hsg-ent-header-status-2 {
        position: relative;
        left: 5%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 7.5%;
    }
    .hsg-header-bar {
        right: 8%;
        top: 4px;
    }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        left: 190px;
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 13%
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        left: 100px;
    }
    .hsg-ent-header-status-2 {
        position: relative;
        left: 7%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 8%;
    }
    .hsg-dotor-details {
        right: 8%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 7.5%;
    }
    .hsg-header-bar {
        right: 8.5%;
        top: 4px;
    }
}

@media screen and (min-width: 1700px) {
    .hsg-ent-header-status-icon-1 > img {
        position: relative;
        left: 280px;
    }
    .hsg-ent-header-status-1 {
        position: relative;
        left: 16%;
    }
    .hsg-ent-header-status-icon-2 > img {
        position: relative;
        left: 160px;
    }
    .hsg-ent-header-status-2 {
        position: relative;
        left: 9%;
    }
    .hsg-ent-doctor {
        position: relative;
        right: 9%;
    }
    .hsg-dotor-details {
        right: 9%;
    }
    .hsg-ent-report-header, .hsg-assessment-date {
        position: relative;
        right: 9%;
    }
    .hsg-header-bar {
        right: 9.5%;
        top: 4px;
    }
   
}

</style>`;

const reportStyleStudentDental = `<style>

.test-img, .test-img-1, .test-img-last {
    text-align: right;
}

.test-img-1 > img {
    width: 165px !important;
    height: 187px !important;
}

.test-img-last > img  {

}

.hsg-rx {
    position: absolute;
    left: 100px;
    top: 2934px;
}

.q11 {
    top: 6px;
    left: 154px;
}

.q12  {
    top: 14px;
    left: 120px;
}

.q13  {
    top: 34px;
    left: 95px;
}

.q14  {
    top: 58px;
    left: 79px;
}
    

.q15  {
    top: 80px;
    left: 65px;
}

.q16  {
    top: 111px;
    left: 54px;
}

.q17  {
    top: 151px;
    left: 49px;
}

.q18  {
    top: 188px;
    left: 48px;
}

.a1  {
    top: 59px;
    left: 164px;
}
.b1  {
    top: 66px;
    left: 142px;
}
.c1  {
    top: 77px;
    left: 126px;
}
.d1  {
    top: 93px;
    left: 116px;
}
.e1  {
    top: 108px;
    left: 108px;
}






.q21  {
    top: 3px;
    left:193px;
}

.q22  {
    top: 14px;
    left: 225px;
}

.q23  {
    top: 34px;
    left: 250px;
}

.q24  {
    top: 57px;
    left: 264px;
}

.q25  {
    top: 79px;
    left: 280px;
}

.q26  {
    top: 112px;
    left: 290px;
}

.q27  {
    top: 150px;
    left: 300px;
}

.q28  {
    top: 188px;
    left: 299px;
}

.a2  {
    top: 58px;
    left: 190px;
}
.b2  {
    top: 66px;
    left: 211px;
}
.c2  {
    top: 79px;
    left: 227px;
}
.d2  {
    top: 94px;
    left: 236px;
}
.e2  {
    top: 108px;
    left: 246px;    
}

.q31  {
    top: 430px;
    left: 154px;
}

.q32  {
    top: 417px;
    left: 120px;
}

.q33  {
    top: 400px;
    left: 95px;
}

.q34  {
    top: 374px;
    left: 78px;
}

.q35  {
    top: 351px;
    left: 64px;
}

.q36  {
    top: 323px;
    left: 51px;
}

.q37  {
    top: 281px;
    left: 48px;
}

.q38  {
    top: 244px;
    left: 49px;
}

.a3  {
    top: 377px;
    left: 163px;
}
.b3  {
    top: 372px;
    left: 142px;
}
.c3  {
    top: 358px;
    left: 126px;

}
.d3  {
    top: 343px;
    left: 115px;
}
.e3  {
    top: 329px;
    left: 106px;
}



.q41  {
    top: 429px;
    left: 195px;
}

.q42  {
    top: 419px;
    left: 227px;
}

.q43  {
    top: 397px;
    left: 253px;

}

.q44  {
    top: 374px;
    left: 265px;
}

.q45  {
    top: 353px;
    left: 281px;
}

.q46  {
    top: 321px;
    left: 295px;
}

.q47  {
    top: 281px;
    left: 298px;
}

.q48  {
    top: 244px;
    left: 298px;
}

.a4  {
    top: 377px;
    left: 187px;
}
.b4  {
    top: 372px;
    left: 208px;
}
.c4  {
    top: 359px;
    left: 226px;    
}
.d4  {
    top: 343px;
    left: 236px;
}
.e4  {
    top: 330px;
    left: 247px;
}



.hsg-footer-text-1 > span {
    position: relative;
    bottom: 6px;
}

.hsg-footer-text-2 > span {
    position: relative;
    bottom: 18px;
}

.hsg-footer-text-3 > span {
    position: relative;
    bottom: 25px;
}

.hsg-tick-icon-2 > img {
    position: relative;
    bottom: 9px;
}

.hsg-tick-icon-3 > img {
    position: relative;
    bottom: 19px;
}


.hsg-decayed, .hsg-missing, .hsg-filling {
    color: #898989 !important;
    font-size: 13px !important;
    font-family: "font", sans-serif !important;
}

.style-1 {
    font-size: 13px !important;
    color: #333333 !important;
    text-transform: uppercase !important;
}

.hsg-dental-doctor {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif !important;
    bottom: 5px;
}

.hsg-dental-stud-info, .style-7, .style-8 {
    color: #333333 !important;
    font-size: 13px !important;
    font-size: 13px !important;
    font-family: "font", sans-serif  !important;
}

.hsg-report-header {
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-assessment-date {
    font-weight: 600 !important;
    font-size: 13px !important;
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-dental-header-status-2, .hsg-dental-header-status-1 {
    color: #333333 !important;
    position: relative;
    top: 5px;
    font-family: "font", sans-serif !important;
}

.hsg-dental-header-status-icon-1 > img {
    position: relative;
    top: 5px;
}
.hsg-dental-header-status-icon-2 > img {
    position: relative;
    top: 5px;
}

.hsg-footer-text-1, .hsg-footer-text-2, .hsg-footer-text-3 {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
    color: #ffffff !important;
}

.hsg-test-header  {
    font-size: 13px !important;
    text-transform: uppercase !important;
    font-family: "fontBold", sans-serif !important;
    font-size: 16px !important;
    left: -1%;
    position: relative;
}

.hsg-verify-header {
    font-family: "fontSemibold", sans-serif  !important;
    font-size: 18px !important;
}

.hsg-footer-header {
    font-family: "fontBold", sans-serif  !important;
    font-size: 16px !important;
}

.hsg-suggested {
    font-family: "fontSemibold", sans-serif  !important;
    border-radius: 30px;
}

.hsg-suggested-remarks {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 16px !important;
}

.hsg-single-test-msg {
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-test-input  {
    font-family: "fontSemibold", sans-serif  !important;
}

.hsg-dotor-details {
    font-family: "font", sans-serif  !important;
    position: relative;
}

.hsg-jaw-html {
    position: absolute;
    left: 27px;
    top: -10px;
    z-index: -2;
}

@media screen and (max-width: 380px) {
    .hsg-dental-jaw {
        position: relative;
        left: 3%;
    }
    .hsg-dmft-jaw-block {
        left: 129px;
        top: 1255px;
    }

}

@media screen and (max-width: 450px) and (min-width: 380px) {
    .hsg-dental-jaw {
        position: relative;
        left: 5%;
    }
    .hsg-dmft-jaw-block {
        left: 145px;
        top: 1282px;
    }
}

@media screen and (max-width: 680px) and (min-width: 450px) {
    .hsg-dental-jaw {
        position: relative;
        left: 9%;
    }
    .hsg-dmft-jaw-block {
        left: 113px;
        top: 1265px;
    }
    .hsg-report-download {
        top: 112px;
        position: relative;
        float: right;
        right: 0px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        left: 1%;  
    }
    .hsg-dental-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: -2%;
    }
    .hsg-dotor-details {
        right: -2%;
    }
    .hsg-header-bar {
        right: 1.5%;
        top: 2px;
    }
    .hsg-report-header , .hsg-assessment-date {
        position: relative;
        right: 0.5%;
        bottom: 4px;        
    }
    .hsg-test-input {
        padding-left: 10px;
    }
}

@media screen and (min-width: 680px) and (max-width: 880px) {
    .hsg-report-download {
        top: 92px;
        right: 15%;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        left: 1%;  
    }
    .hsg-dental-header-status-2 {
        position: relative;
        left: 1%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: -2%;
    }
    .hsg-dotor-details {
        right: -2%;
    }
    .hsg-header-bar {
        right: 1.5%;
        top: 2px;
    }
    .hsg-report-header , .hsg-assessment-date {
        position: relative;
        right: 0.5%;
        bottom: 4px;        
    }
    .hsg-test-input {
        padding-left: 10px;
    }
    .hsg-dental-jaw {
        position: relative;
        left: 7.8%;
    }
    .hsg-dmft-jaw-block {
        left: 22.4%;
    }
}

@media screen and (min-width: 880px) and (max-width: 1023px){
    .hsg-dental-header-status-icon-1 > img {
        position: relative;
        right: 45px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        right: 4.5%;   
    }
    .hsg-dental-header-status-icon-2 > img {
        position: relative;
        right: 65px;
    }
    .hsg-dental-header-status-2 {
        position: relative;
        right: 7%
    }
    .hsg-dental-doctor {
        position: relative;
        right: 3%;
    }
    .hsg-dotor-details {
        right: 3%;
    }
    .hsg-header-bar {
        right: 4.5%;
        top: 2px;
    }
    .hsg-report-header , .hsg-assessment-date {
        position: relative;
        right: 3.5%;
        bottom: 4px;        
    }
    .hsg-dental-jaw {
        position: relative;
        left: 7.5%;
    }
    .hsg-dmft-jaw-block {
        left: 28.4%;
    }
    .hsg-decayed {
        position: relative;
        left: 15%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 15%;
    }

    .hsg-missing {
        position: relative;
        left: 5%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 5.5%;
    }
    .hsg-filling {
        position: relative;
        right: 4%
    }

    .hsg-filling-icon{
        position: relative;
        right: 5%
    }
}

@media screen and (min-width: 1023px) and (max-width: 1290px){
    .hsg-dental-header-status-icon-1 > img {
        position: relative;
        right: 20px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        right: 1%;
    }
    .hsg-dental-header-status-icon-2 > img {
        position: relative;
        right: 20px;
    }
    .hsg-dental-header-status-2 {
        position: relative;
        right: 1%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: 5%;
    }
    .hsg-dotor-details {
        right: 5%;
    }
    .hsg-header-bar {
        right: 6%;
        top: 2px;
    }
    .hsg-report-header , .hsg-assessment-date {
        position: relative;
        right: 5%;
        bottom: 4px;        
    }
    .hsg-dental-jaw {
        position: relative;
        left: 7%;
        top: 6px;
    }
    .hsg-dmft-jaw-block {
        left: 31%;
        top: 1245px;
    }
    .hsg-decayed {
        position: relative;
        left: 15%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 15%;
    }

    .hsg-missing {
        position: relative;
        left: 4%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 4.5%;
    }
    .hsg-filling {
        position: relative;
        right: 6%
    }

    .hsg-filling-icon{
        position: relative;
        right: 6%
    }
}

@media screen and (min-width: 1290px) and (max-width: 1500px){
    .hsg-dental-header-status-icon-1 > img {
        position: relative;
        left: 80px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        left: 6%;
    }
    .hsg-dental-header-status-icon-2 > img {
        position: relative;
        left: 40px;
    }
    .hsg-dental-header-status-2 {
        position: relative;
        left: 3%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-header-bar {
        right: 8%;
        top: 2px;
    }
    .hsg-report-header  , .hsg-assessment-date{
        position: relative;
        right: 7.5%;
        bottom: 4px;        
    }
    .hsg-dental-jaw {
        position: relative;
        left: 7.1%;
    }
    .hsg-dmft-jaw-block {
        left: 30.4%;
    }
    .hsg-decayed {
        position: relative;
        left: 15.5%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 16%;
    }

    .hsg-missing {
        position: relative;
        left: 3.5%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 4.5%;
    }
    .hsg-filling {
        position: relative;
        right: 9%
    }

    .hsg-filling-icon{
        position: relative;
        right: 8.5%
    }

}

@media screen and (min-width: 1500px) and (max-width: 1700px){
    .hsg-dental-header-status-icon-1 > img {
        position: relative;
       left: 130px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        left: 9%;
    }
    .hsg-dental-header-status-icon-2 > img {
        position: relative;
        left:70px;
    }
    .hsg-dental-header-status-2 {
        position: relative;
       left:5%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-header-bar {
        right: 8.5%;
        top: 2px;
    }
    .hsg-report-header , .hsg-assessment-date {
        position: relative;
        right: 7.5%;
        bottom: 4px;        
    }
    .hsg-dental-jaw {
        position: relative;
        left: 7%;
    }
    .hsg-dmft-jaw-block {
        left: 33.4%;
    }
    .hsg-decayed {
        position: relative;
        left: 17.5%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 18%;
    }

    .hsg-missing {
        position: relative;
        left: 4%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 5%;
    }
    .hsg-filling {
        position: relative;
        right: 9%
    }

    .hsg-filling-icon{
        position: relative;
        right: 8.5%
    }
}



@media screen and (min-width: 1700px) and (max-width: 1900px){
    .hsg-dental-header-status-icon-1 > img {
        position: relative;
        left: 270px;
    }
    .hsg-dental-header-status-1 {
        position: relative;
        left: 15%;
    }
    .hsg-dental-header-status-icon-2 > img {
        position: relative;
        left: 160px;
    }
    .hsg-dental-header-status-2 {
        position: relative;
        left: 9%;
    }
    .hsg-header-bar {
        right: 9.5%;
        top: 1px;
    }
    .hsg-report-header, .hsg-assessment-date {
        position: relative;
        right: 9%;
        bottom: 5px;
    }
    .hsg-dental-doctor {
        position: relative;
        right: 9%;
    }
    .hsg-dotor-details {
        right: 9%;
    }
    .hsg-dental-jaw {
        position: relative;
        left: 11.5%;
    }
    .hsg-dmft-jaw-block {
        left: 36.7%;
    }
    .hsg-decayed {
        position: relative;
        left: 17.5%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 18%;
    }

    .hsg-missing {
        position: relative;
        left: 4%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 5%;
    }
    .hsg-filling {
        position: relative;
        right: 9%
    }

    .hsg-filling-icon{
        position: relative;
        right: 8.5%
    }
}

@media screen and (min-width: 1900px) {
    .hsg-dental-jaw {
        position: relative;
        left: 11.1%;
    }
    .hsg-dmft-jaw-block {
        left: 36.7%;
    }
    .hsg-dental-doctor {
        position: relative;
        right: 9%;
    }
    .hsg-dotor-details {
        right: 9%;
    }
    .hsg-report-header, .hsg-assessment-date {
        position: relative;
        right: 9%;
        bottom: 5px;
    }
    .hsg-header-bar {
        position: relative;
        right: 9.5%;
        bottom: 0 !important;
    }
    .hsg-decayed {
        position: relative;
        left: 17.5%;
    }
    .hsg-decayed-icon {
        position: relative;
        left: 18%;
    }

    .hsg-missing {
        position: relative;
        left: 4%;
    }

    .hsg-missing-icon  {
        position: relative;
        left: 5%;
    }
    .hsg-filling {
        position: relative;
        right: 9%
    }

    .hsg-filling-icon{
        position: relative;
        right: 8.5%
    }
}


</style>`;

const reportStyleStudentGrowth = `<style>

.hsg-rx-g1 {
    position: absolute;
    top: 573px;
    left: 105px;
}

.hsg-rx-g2 {
    position: absolute;
    top: 1358px;
    left: 105px;
}

.hsg-growth-instruct-ticks-1 > img {
    position: relative;
    top: 9px;
}

.hsg-growth-footer-text-2  > span {
    position: relative;
    bottom: 9px;
}

.hsg-growth-footer-text-3 > span {
    position: relative;
    bottom: 21px;
}

.hsg-growth-instruct-ticks-3 > img {
    position: relative;
    bottom: 9px;
}

.hsg-growth-footer-text-4 > span {
    position: relative;
    bottom: 9px;
}

.hsg-growth-footer-text-5 > span {
    position: relative;
    bottom: 13px;
}

.hsg-growth-footer-text-6 > span {
    position: relative;
    bottom: 25px;
}

.hsg-growth-instruct-tick-6 > img {
    position: relative;
    bottom: 7px;
}

.style-28 > img {
    position: relative;
    top: 4px;
    left: 13%;
}

// .style-12 {
//     position: relative;
//     right: 7px;
// }

.hsg-growth-note {
    font-size: 18px !important;
    font-family: fontSemibold !important;
    font-style: italic;
}

style-1 {
    font-size: 13px !important;
    color: #333333 !important;
    text-transform: uppercase !important;
}

.style-14 {
    font-family: "font", sans-serif !important;
}

.hsg-verify-header {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 18px;
}

.hsg-footer-header {
    font-family: "fontBold", sans-serif !important;
    font-size: 16px !important;
}

.hsg-growth-footer-text-1, .hsg-growth-footer-text-2, .hsg-growth-footer-text-3, .hsg-growth-footer-text-4, .hsg-growth-footer-text-5, .hsg-growth-footer-text-6  {
    font-family: "fontSemibold", sans-serif !important;
    font-size: 13px !important;
    color: #ffffff !important;
}

.hsg-growth-weight-label > span, .hsg-growth-height-label > span, .hsg-growth-bmi-label > span {
    font-family: "font", sans-serif;
    font-size: 14px !important;
}


.hsg-growth-stud-info {
    color: #333333 !important;
    font-size: 13px !important;
}

.hsg-growth-report-header {
    color: #333333 !important;
    font-family: "fontSemibold", sans-serif !important;
}
.hsg-assessment-date {
    font-family: "fontSemibold", sans-serif !important;
}

.hsg-dotor-details {
    font-family: "font", sans-serif  !important;
    position: relative;
    bottom: 9px;
}

.hsg-growth-stud-info > span {
    color: #333333 !important;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-test-header {
    font-family: "FontBold", sans-serif !important;
    position: relative;
    left: -13px;
}

.hsg-growth-report-header {
    color: #333333 !important;
    font-weight: 600 !important;
}


.hsg-header-bar {
    position: relative;
}

.hsg-growth-height {
    font-size: 30px !important;
    position: relative;
    bottom: 31px;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-stud-info {
    color: #333333 !important;
}

.style-10 {
    color: #333333 !important;
}

.style-15, .style-16 {
    color: white !important;    
}

.hsg-growth-weight {
    font-size: 30px !important;
    position: relative;
    bottom: 30px;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-bmi {
    font-size: 26px !important;
    position: relative;
    bottom: 45px;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-doctor {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    font-family: "fontSemibold", sans-serif !important;
    position: relative;
    bottom: 19px;
    font-family: "fontBold", sans-serif  !important;
}

.hsg-growth-height-label {
    font-size: 14px !important;
    line-height: 2;
    color: #333333 !important;
    position: relative;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-height-label > span {
    margin-right: 5px;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-weight-label {
    font-size: 14px !important;
    line-height: 2;
    color: #333333 !important;
    position: relative;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-weight-label > span {
    margin-right: 5px;
    font-family: "font", sans-serif  !important;
}

.hsg-growth-bmi-label {
    font-size: 13px !important;
    line-height: 2;
    color: #333333 !important;
    position: relative;
}

.hsg-growth-bmi-label > span {
    margin-right: 5px;
    font-family: "font", sans-serif  !important;
}

.high {
    background: #9a7bb7;
    color: white;
    padding: 2px 8px;
}

@media screen and (max-width: 800px) {
    .hsg-growth-height {
        left: 18%;
    }
    .hsg-growth-weight {
        left: 18%;
    }
    .hsg-growth-bmi {
        left: 15%;
    }
    .hsg-growth-doctor {
        right: -4%;
    }
    .hsg-dotor-details {
        right: -4%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 36%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 36%;
        bottom: 8px;
    }
    .hsg-growth-report-header , .hsg-assessment-date{
        position: relative;
        right: -1%;
    }
    .hsg-header-bar {
        right: 0%;
        top: 4px;
    }
    .hsg-growth-test-header {
        left: 0px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        
    }
}

@media screen and (min-width: 800px) and (max-width: 880px){
    .hsg-growth-height {
        left: 16.5%;
    }
    .hsg-growth-weight {
        left: 16.5%;
    }
    .hsg-growth-bmi {
        left: 14.5%;
    }
    .hsg-growth-doctor {
        right: 2.5%;
    }
    .hsg-dotor-details {
        right: 2.5%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
       left: 34.5%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 34.5%;
        bottom: 8px;
    }
    .hsg-growth-report-header , .hsg-assessment-date{
        position: relative;
        right: 0%;
    }
    .hsg-header-bar {
        right: 8.5%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 3%;
    }
}

@media screen and (min-width: 880px) and (max-width: 1023px){
    .hsg-growth-height {
        left: 15%;
    }
    .hsg-growth-weight {
        left: 15%;
    }
    .hsg-growth-bmi {
        left: 14%;
    }
    .hsg-growth-doctor {
        right: 2.5%;
    }
    .hsg-dotor-details {
        right: 2.5%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 34%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 34%;
        bottom: 8px;
    }
    .hsg-growth-report-header, .hsg-assessment-date {
        position: relative;
        right: 3%;
    }
    .hsg-header-bar {
        right: 4.5%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 3%;
    }
}

@media screen and (min-width: 1023px) and (max-width: 1290px){
    .hsg-growth-height {
        left: 13%;
    }
    .hsg-growth-weight {
        left: 13%;
    }
    .hsg-growth-bmi {
        left: 12.5%;
    }
    .hsg-growth-doctor {
        right: 5.5%;
    }
    .hsg-dotor-details {
        right: 5.5%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 33%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 33%;
        bottom: 8px;
    }
    .hsg-growth-report-header , .hsg-assessment-date{
        position: relative;
        right: 6.2%;
    }
    .hsg-header-bar {
        right: 6.7%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 7%;
    }
}

@media screen and (min-width: 1290px) and (max-width: 1500px){
    .hsg-growth-height {
        left: 13%;
    }
    .hsg-growth-weight {
        left: 12.7%;
    }
    .hsg-growth-bmi {
        left: 12.6%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 32%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 32%;
        bottom: 8px;
    }
    .hsg-growth-doctor {
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-growth-report-header , .hsg-assessment-date{
        position: relative;
        right: 7%;
    }
    .hsg-header-bar {
        right: 7.5%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 10%;
    }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
    .hsg-growth-height {
       left: 12%;
    }
    .hsg-growth-weight {
        left: 12.4%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 31.5%;
        bottom: 8px;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 31.5%;
        bottom: 8px;
    }
    .hsg-growth-bmi {
        left: 12%;
    }
    .hsg-growth-doctor {
        right: 7%;
    }
    .hsg-dotor-details {
        right: 7%;
    }
    .hsg-growth-report-header, .hsg-assessment-date {
        position: relative;
        right: 8%;
    }
    .hsg-header-bar {
        right: 8.5%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 10%;
    }

    .hsg-rx-g1 {
        position: absolute;
        top: 573px;
        left: 130px;
    }

    .hsg-rx-g2 {
        position: absolute;
        top: 1358px;
        left: 130px;
    }

}

@media screen and (min-width: 1700px) {
    .hsg-growth-height {
       left: 11.3%;
    }
    .hsg-growth-height-unit {
        position: relative;
        color: #ffffff !important;
        left: 31%;
        bottom: 10px;
    }
    .hsg-growth-weight {
        left: 11.5%;
    }
    .hsg-growth-weight-unit {
        position: relative;
        color: #ffffff !important;
        left: 31%;
        bottom: 8px;
    }
    .hsg-growth-bmi {
        left: 11.3%;
    }
    .hsg-growth-doctor {
        right: 8%;
    }
    .hsg-dotor-details {
        right: 8%;
    }
    .hsg-growth-report-header , .hsg-assessment-date{
        position: relative;
        right: 9%;
    }
    .hsg-header-bar {
        right: 9.5%;
        top: 4px;
    }
    .hsg-growth-stud-info {
        position: relative;
        bottom: 15px;
    }
    .hsg-growth-height-label, .hsg-growth-weight-label, .hsg-growth-bmi-label {
        right: 12%;
    }
    .hsg-rx-g1 {
        position: absolute;
        top: 573px;
        left: 130px;
    }

    .hsg-rx-g2 {
        position: absolute;
        top: 1358px;
        left: 130px;
    }
}

</style>

`;

const reportStyleStudentClassMap = {
  dental: reportStyleStudentDental,
  ent: reportStyleStudentENT,
  eye: reportStyleStudentEye,
  growth: reportStyleStudentGrowth,
  physical: reportStyleStudentPhysical,
};

const reportMap = {
  student: reportStyleStudentClassMap,
  school: reportStyleClassMap,
};

class FrameComponent extends Component {
  componentDidMount() {
    this.adjustIframeHeight();
  }

  componentWillReceiveProps(newProps) {
    if (
      JSON.stringify(newProps.htmlContent) !==
      JSON.stringify(this.props.htmlContent)
    ) {
      this.adjustIframeHeight();
    }
  }

  adjustIframeHeight = () => {
    setTimeout(() => {
      const iframeDOMNode = ReactDOM.findDOMNode(this.iframeRef);

      if (
        iframeDOMNode &&
        iframeDOMNode.contentWindow &&
        iframeDOMNode.contentWindow.document &&
        iframeDOMNode.contentWindow.document.body &&
        iframeDOMNode.height !==
          iframeDOMNode.contentWindow.document.body.scrollHeight
      ) {
        iframeDOMNode.height = iframeDOMNode.contentWindow.document.body
          .scrollHeight
          ? iframeDOMNode.contentWindow.document.body.scrollHeight
          : "auto";
        let parentHeight = iframeDOMNode.contentWindow.document.body
          .scrollHeight
          ? iframeDOMNode.contentWindow.document.body.scrollHeight + 20
          : "auto";
        this.props.changeHeight(parentHeight);
      }
    }, 200);
  };

  onMount() {
    setTimeout(this.adjustIframeHeight, 200);
  }

  onUpdate() {
    this.adjustIframeHeight();
  }

  _renderBarLine = () => {
    return <img className="hsg-bar-line" src={barLine} />;
  };

  _renderRxBackground = () => {
    if (this.props.htmlContent && !this.props.student)
      return <img className="hsg-rx-bg" src={Rxbg} />;
    else return null;
  };

  _renderOptometry = () => {
    if (this.props.reportType === "eye") {
      let leftEye = null,
        rightEye = null;
      let optometryIndex = this.props.dmftIndex;

      if (optometryIndex) {
        optometryIndex = optometryIndex.filter((eye, i) => {
          if (eye.value === "Y" && eye.type === "optometry") {
            return true;
          }
        });

        optometryIndex.map((eye, i) => {
          let tempArr = eye.index_name.split("_");

          if (tempArr.includes("Right")) {
            rightEye = tempArr[tempArr.length - 1];
          } else {
            leftEye = tempArr[tempArr.length - 1];
          }
        });
      }
      return (
        <div className="hsg-optometry">
          <div>
            <div className="left-eye-block">
              <span className="left-eye"> {`6/${leftEye || 6}`}</span>
              <h5 class="vision-title">Left Eye</h5>
            </div>
            <img src={OptometryImage} />
            <div className="right-eye-block">
              <span className="right-eye">{`6/${rightEye || 6}`}</span>
              <h5 class="vision-title">Right Eye</h5>
            </div>
          </div>
        </div>
      );
    } else return null;
  };

  _renderJawDefects = () => {
    if (this.props.reportType === "dental") {
      let dmftIndex = this.props.dmftIndex;
      let jawDefects = null,
        jaw = [];

      if (dmftIndex) {
        let reqTeeth = null;

        dmftIndex = dmftIndex.filter((teeth, i) => {
          if (teeth.value === "Y" && teeth.type === "dmft_index") {
            return true;
          }
        });
        ///^Q[1-8]__[a-e]_[DMF]/.test(teeth.)
        let backgroundColor = "",
          teethClass = "";
        jawDefects = dmftIndex.map((teeth, i) => {
          teethClass = teeth.index_name.replace("__", "");
          teethClass = teethClass.replace("_", "").toLowerCase();
          teethClass = teethClass.slice(0, -1);

          // teeth.props.style.opacity = 1
          let disease = teeth.index_name.charAt(teeth.index_name.length - 1);

          if (disease === "D") {
            backgroundColor = "#b93f69";
          } else if (disease === "M") {
            backgroundColor = "#bc2e28";
          } else if (disease === "F") {
            backgroundColor = "#1f8acf";
          }

          if (/[a-e]/i.test(teethClass)) {
            teethClass = teethClass.replace(
              "q",
              teethClass[teethClass.length - 1]
            );
            teethClass = teethClass.slice(0, -1);
            return (
              <div
                key={i}
                className={teethClass}
                name={teeth.index_name}
                style={{
                  height: 14,
                  width: 14,
                  position: "absolute",
                  opacity: 1,
                  textAlign: "center",
                  background: backgroundColor,
                  borderRadius: 10,
                }}
              >
                <span
                  style={{
                    textTransform: "uppercase",
                    fontSize: 11,
                    color: "#ffffff",
                    position: "relative",
                    bottom: 2,
                  }}
                >
                  {teeth.index_name.split("")[4]}
                </span>
              </div>
            );
          } else {
            return (
              <div
                key={i}
                className={teethClass}
                name={teeth.index_name}
                style={{
                  height: 20,
                  width: 20,
                  position: "absolute",
                  opacity: 1,
                  textAlign: "center",
                  background: backgroundColor,
                  borderRadius: 10,
                }}
              >
                <span
                  style={{
                    color: "#ffffff",
                    textTransform: "uppercase",
                    fontSize: 14,
                    position: "relative",
                    top: 2,
                  }}
                >
                  {teeth.index_name.split("")[4]}
                </span>
              </div>
            );
          }
        });
      }

      return (
        <div className="hsg-dmft-jaw-block">
          {jawDefects}
          {
            <div className="hsg-jaw-html">
              <img src={JawImage} height={467} />
            </div>
          }
        </div>
      );
    } else return null;
  };

  render() {
    return (
      <Frame
        className="hsg-reportFrame"
        initialContent={`<!DOCTYPE html><html><head><link href="https://fonts.googleapis.com/css?family=Exo+2" rel="stylesheet">${
          this.props.student ? reportsStudentStyles : reportsStyles
        }${
          this.props.reportType
            ? reportMap[this.props.student ? "student" : "school"][
                this.props.reportType
              ]
            : ""
        }</head><body><div></div></body></html>`}
        ref={(node) => (this.iframeRef = node)}
        contentDidMount={() => this.onMount}
        contentDidUpdate={() => this.onUpdate}
      >
        {this.props.student && this.props.CMSImage}
        {this.props.student && this._renderJawDefects()}
        {this.props.student && this._renderOptometry()}
        {this._renderRxBackground()}
        {this.props.downloadBtn}
        {Parser(this.props.htmlContent)}
        {!this.props.student && this._renderBarLine()}
      </Frame>
    );
  }
}

export default FrameComponent;
